import React, { Component, createRef } from "react";
import { addDays, differenceInCalendarDays, format, isBefore } from "date-fns";
import { getSupplierList } from "../../../../lib/getSupplierList";

import { getAirlines } from "../../../../lib/getAirlines";
import cf from "../../../../lib/utils/common";
import B2BWidgets from "../../../b2bwidgets/index";
import DesktopCalender from "../../../calendar/flightCalender/theme4/DesktopCalender";
import MultiSuppilerDropDownoption from "../../../multiDropdown/theme4/index";
import MultiSelectDropDown from "../../../multiSelect/multiSelectDropDown";
import FlightAutoComplete from "./FlightAutoComplete";
import PaxConfig from "./PaxConfig";
import { getUrl, parseurl } from "../../../../lib/flight/urlParser";
import MobileCalender from "../../../calendar/flightCalender/theme4/MobileCalender";
import B2BWidgetsMobile from "../../../b2bwidgets/theme4/mobile/index";
import ModalPopupComponent from "../../../ModalPopupComponent/theme5/ModalPopupComponent";

import MultiSuppilerDropDownoptionMoblie from "../../../multiDropdown/theme4/mobile";
import MultiSelectDropDownMobile from "../../../multiselectMobile/multiSelectDropDownMobile";
import { offlineCreateEnquiry } from "../../../../../common/lib/enquiry";
import SpecialFareType from "../../../HomePageComponent/Flight/FareTypeSelection/index.js";
import getFareType from "../../../../lib/getFareType";
import { getAdvanceAirlineList } from "../../../../../common/lib/getAdvanceAirlineList";
import { checksession } from "../../../../../common/lib/checksession";
const cabinClass = [
  { id: 1, value: "Economy", label: "Economy" },
  { id: 2, value: "Business", label: "Business" },
  { id: 3, value: "First Class", label: "First Class" },
  { id: 4, value: "Premium Economy", label: "Premium Economy" },
];

const rbdClass = [
  { label: "All", value: "*", isChecked: false },
  { label: "A", value: "A", isChecked: false },
  { label: "B", value: "B", isChecked: false },
  { label: "C", value: "C", isChecked: false },
  { label: "D", value: "D", isChecked: false },
  { label: "E", value: "E", isChecked: false },
  { label: "F", value: "F", isChecked: false },
  { label: "G", value: "G", isChecked: false },
  { label: "H", value: "H", isChecked: false },
  { label: "I", value: "I", isChecked: false },
  { label: "J", value: "J", isChecked: false },
  { label: "K", value: "K", isChecked: false },
  { label: "L", value: "L", isChecked: false },
  { label: "M", value: "M", isChecked: false },
  { label: "N", value: "N", isChecked: false },
  { label: "O", value: "O", isChecked: false },
  { label: "P", value: "P", isChecked: false },
  { label: "Q", value: "Q", isChecked: false },
  { label: "R", value: "R", isChecked: false },
  { label: "S", value: "S", isChecked: false },
  { label: "T", value: "T", isChecked: false },
  { label: "U", value: "U", isChecked: false },
  { label: "V", value: "V", isChecked: false },
  { label: "W", value: "W", isChecked: false },
  { label: "X", value: "X", isChecked: false },
  { label: "Y", value: "Y", isChecked: false },
  { label: "Z", value: "Z", isChecked: false },
];

let TripType = [
  { id: 1, value: "oneWay", label: "One Way", show: true },
  { id: 2, value: "roundTrip", label: "Round Trip", show: true },
  { id: 3, value: "Multicity", label: "Multicity", show: true },
];

const DepartureTime = [
  { label: "All", value: "All", isChecked: true, code: "All" },
  {
    label: "Before 6 AM",
    value: "Before 6 AM",
    isChecked: false,
    code: "00000559",
  },
  {
    label: "6 AM - 12 PM",
    value: "6 AM - 12 PM",
    isChecked: false,
    code: "06001159",
  },
  {
    label: "12 PM - 6 PM",
    value: "12 PM - 6 PM",
    isChecked: false,
    code: "12001759",
  },
  {
    label: "After 6 PM",
    value: "After 6 PM",
    isChecked: false,
    code: "18002359",
  },
];

const fareTypeMsg = {
  STDF: "Applicable only for students above 12 years of age. Valid student ID cards and student visas (where applicable) are required to avail this.",
  ARMY: "Applicable only for serving/retired Indian Armed Forces personnel & their dependents. A valid Armed Forces ID or dependent card is required at the airport to avail this.",
  SCTZ: "Applicable only for senior citizens above the age of 60 years. A valid proof of Date of Birth is required at the airport to avail this.",
};

let bookingType = [
  {
    name: "business",
    value: "Business",
    label: "Business",
    tripId: 1,
    selected: false,
    show: false,
  },
  {
    name: "annual",
    value: "Annual Trip",
    label: "Annual Trip",
    tripId: 2,
    selected: false,
    show: false,
  },
  {
    name: "personal",
    value: "Personal",
    label: "Personal",
    tripId: 3,
    selected: false,
    show: false,
  },
  {
    name: "exceptional",
    value: "Exceptional",
    label: "Exceptional",
    tripId: 4,
    selected: false,
    show: false,
  },
];
let airline = [];
const todaysDate = format(new Date(), "dd-LLL-yyyy");
export default class Theme1 extends Component {
  constructor(props) {
    super(props);
    this.setState = this.setState.bind(this);
    this.guestDetailWrapper = createRef();
    this.economyPopUpWrapper = createRef();
    this.advanceSearchWrapper = createRef();
    this.passengerDropdownWrapper = createRef();
    this.travellerCabin = createRef();
    this.multicityDepartureWrapper = createRef();
    this.multicityReturnWrapper = createRef();
    this.multicityClassWrapper = createRef();
    this.departureListWrapper = createRef();
    this.returnListWrapper = createRef();
    this.setDropdownWrapperRef = createRef();
    this.box = createRef(null);
    this.state = {
      departureAirPortName: "",
      goingToAirPortName: "",
      isOnewaySearch: true,
      departureValue: "",
      goingToValue: "",
      expandDepartureBoolean: false,
      expandGoingToBoolean: false,
      departureDateValue: format(new Date(), "dd-LLL-yyyy"),
      goingToDateValue: format(addDays(new Date(), 7), "dd-LLL-yyyy"),
      expandDepartureDateBoolean: false,
      expandGoingToDateBoolean: false,
      paxAdultValue: 1,
      paxChildrenValue: 0,
      paxInfantValue: 0,
      SelectedClassValue: { label: "Economy", id: 1 },
      openCabinClassList: false,
      getDepartureSuggestionList: [],
      getGoingToSuggestionList: [],
      getDepartureAirportCode: "",
      getGoingToAirportCode: "",
      openCabinClassListOne: false,
      isError: {
        departure: false,
        goingTo: false,
        departureDate: false,
        goingToDate: false,
      },
      returnCity: "",
      departureCity: "",
      isMultiCitySearch: false,
      openPaxList: false,
      guest_id: "",
      travellerCabinClass: { label: "Economy", id: 1 },
      EmployeeError: "",
      FlightData: [
        {
          flight: 1,
          src: "",
          srcValue: "",
          dest: "",
          destValue: "",
          showsrcDropdown: false,
          showdestDropdown: false,
          departureDate: format(new Date(), "dd-LLL-yyyy"),
          returnDate: format(addDays(new Date(), 7), "dd-LLL-yyyy"),
          showdepartureDateDropdown: false,
          showreturnDateDropdown: false,
          advancesearch: {
            airlines: [],
            fcs: JSON.parse(JSON.stringify(rbdClass)),
            dtym: JSON.parse(JSON.stringify(DepartureTime)),
            cabinclass: { label: "Economy", id: 1 },
            showCabinClassList: false,
          },
          flexiBaggage: true,
          error: {
            colleagueError: "",
            srcErrMsg: "",
            destErrMsg: "",
            rbdCabinErrMsg: "",
            rbdErrMsg: "",
            passengerError: "",
            // rbdCabinClassErrMsg:""
          },
          bagreq: true,
          odt: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
          disabledDate: cf.getDateWithFormat(
            new Date(),
            this?.props?.dateFormat
          ),
        },
      ],
      travellerCabin: false,
      selectedTripType: "oneWay",
      showTraveller: false,
      pax: {
        adults: 1,
        child: 0,
        infants: 0,
      },
      isAdvanceSearch: false,
      bookingTypeId: "",
      isguestChecked: false,
      bookingType: [
        {
          name: "business",
          value: "Business",
          label: "Business",
          tripId: 1,
          selected: false,
          show: false,
        },
        {
          name: "annual",
          value: "Annual Trip",
          label: "Annual Trip",
          tripId: 2,
          selected: false,
          show: false,
        },
        {
          name: "personal",
          value: "Personal",
          label: "Personal",
          tripId: 3,
          selected: false,
          show: false,
        },
        {
          name: "exceptional",
          value: "Exceptional",
          label: "Exceptional",
          tripId: 4,
          selected: false,
          show: false,
        },
      ],
      TripType: [
        { id: 1, value: "oneWay", label: "One Way", show: true },
        { id: 2, value: "roundTrip", label: "Round Trip", show: true },
        { id: 3, value: "Multicity", label: "Multicity", show: true },
      ],
      employeeguestId: [],
      onLoadPopup: false,
      showbookingTypeError: false,
      enquiry_id: "",
      guestBookingType: [...bookingType],
      modalPopupValue: "",
      guestTripType: [...TripType],
      showErrorMsg: "",
      isLoading: false,
      faretypelist: [],
      showAbove: false,
      userProfile: "",
      btnLoader: false,
      etPolicy: false,
      colleagueEtRule: {},
    };

    this.box = createRef(null);
  }
  async componentDidMount() {
    // console.log("aaaaaaaaaaaaaaaaaa",this.props);
    let FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    console.log("isSRPsssssssssss", this.props.isSRP, this.props);
    if (this.props.isSRP) {
      if (this.props.FlightData && this.props.FlightData.length) {
        this.props.FlightData.forEach((flightObj, id) => {
          console.log(
            "🚀 ~ file: index.js:168 ~ Theme1 ~ this.props.FlightData.forEach ~ flightObj:",
            flightObj
          );
          if (this.props.tripType !== "1" && id !== 0) {
            flightObj.disabledDate =
              this.props.FlightData[id - 1].departureDate;
            console.log("flightObj.disabledDate", flightObj.disabledDate);
          }
          // rbd Class
          let rbdClass1 = JSON.parse(JSON.stringify(rbdClass));
          if (flightObj.advancesearch.fcs.length) {
            let tempOptions = flightObj.advancesearch.fcs;
            let temprdbOptions = JSON.parse(JSON.stringify(rbdClass));
            for (let i = 0; i < temprdbOptions.length; i++) {
              if (tempOptions.includes(temprdbOptions[i].value)) {
                temprdbOptions[i].isChecked = true;
              }
            }
            rbdClass1 = temprdbOptions;
          }
          flightObj.advancesearch.fcs = rbdClass1;
          // rbd Class

          // dtym Class
          let departureTime = JSON.parse(JSON.stringify(DepartureTime));
          if (flightObj.advancesearch.dtym.length) {
            let tempOptions = flightObj.advancesearch.dtym;
            console.log("tempOptionsfgh", tempOptions);

            let temprdbOptions = JSON.parse(JSON.stringify(DepartureTime));
            if (!tempOptions[0]) {
              tempOptions[0] = "All";
            }
            for (let i = 0; i < temprdbOptions.length; i++) {
              //  console.log("tempOptions.includes(temprdbOptions[i].value",tempOptions.includes(temprdbOptions[i].code))
              if (tempOptions.includes(temprdbOptions[i].code)) {
                temprdbOptions[i].isChecked = true;
              } else {
                temprdbOptions[i].isChecked = false;
              }
            }

            departureTime = temprdbOptions;
          }
          flightObj.advancesearch.dtym = departureTime;
          // dtym Class
          let tempCambin =
            flightObj.advancesearch.cabinclass &&
            typeof flightObj.advancesearch.cabinclass == "string"
              ? cabinClass.find(
                  (ele) => ele.id == flightObj?.advancesearch?.cabinclass
                )
              : flightObj.advancesearch.cabinclass;

          // cabin Class
          // flightObj.advancesearch.cabinclass = cabinClass.find((ele) => ele.id == flightObj.advancesearch.cabinclass ) || { label: "Economy", id: 1 }
          if (
            flightObj.advancesearch.cabinclass &&
            typeof flightObj.advancesearch.cabinclass == "string"
          ) {
            flightObj.advancesearch.cabinclass = JSON.parse(
              JSON.stringify(tempCambin)
            ) || { label: "Economy", id: 1 };
          }
          // cabin Class
          if (id == 0 && flightObj.advancesearch.cabinclass) {
            console.log("tempCambin", tempCambin);
            this.setState(
              {
                travellerCabinClass: JSON.parse(JSON.stringify(tempCambin)) || {
                  label: "Economy",
                  id: 1,
                },
              },
              () => {
                console.log(
                  "🚀 ~ file: index.js:221 ~ Theme1 ~ this.props.FlightData.forEach ~ travellerCabinClass:",
                  this.state.travellerCabinClass,
                  flightObj?.advancesearch?.cabinclass
                );
              }
            );
          }

          // if (id == 0) {
          //   this.setState({
          //     travellerCabinClass: cabinClass.find((ele) => ele.id == parseInt(flightObj.advancesearch.cabinclass.id)) || { label: "Economy", id: 1 },
          //   },()=>{
          //     console.log("🚀 ~ file: index.js:221 ~ Theme1 ~ this.props.FlightData.forEach ~ travellerCabinClass:", this.state.travellerCabinClass ,flightObj?.advancesearch?.cabinclass)

          //   })
          // }
        });

        FlightDataCopy = JSON.parse(JSON.stringify(this.props.FlightData));
        console.log("🚀 ~ FlightDataCopy1:", FlightDataCopy);
      }
      // console.log("this.props.isguestChecked",this.props.isguestChecked==="true"?true:false);
      this.setState({
        isguestChecked: this.props.isguestChecked === "true" ? true : false,
      });

      if (this.props.employeeguestIdList?.length > 0) {
        this.setState({ employeeguestId: this.props.employeeguestIdList });
      }

      let trip = this.state.TripType.find(
        (ele) => ele.id == this.props.tripType
      );

      this.bookingTypeMethod(Number(this.props.bookingType));

      this.setState(
        {
          selectedTripType: trip.value,
          isAdvanceSearch: this.props.isAdvanceSearch,
          pax: this.props.pax,
          guest_id: this.props.guest_id || "",
          bookingTypeId: this.props.bookingType,
        },
        () => {
          this.fetchGuestDetail();
        }
      );
    }

    this.setState({
      FlightData: FlightDataCopy,
    });

    getFareType().then((res) => {
      if (res && res?.data && res?.data?.length > 0) {
        console.log("res?.data?=========", res?.data);
        let fareType = res?.data?.map((ele, id) => {
          return {
            label: ele.pax_type,
            value: ele.pax_type,
            isChecked: false,
            code: ele.pax_code,
            msg: fareTypeMsg?.[ele.pax_code] ? fareTypeMsg[ele.pax_code] : "",
          };
        });
        this.setState(
          {
            faretypelist: fareType,
          },
          () => {
            if (this.props.FareType?.length > 0) {
              const url = window.location.href;
              const urlSearchParams = new URLSearchParams(url.split("?")[1]);
              const splfare = urlSearchParams.get("splfare");
              if (splfare) {
                let tempOption = JSON.parse(JSON.stringify(fareType));
                tempOption.forEach((element) => {
                  if (element.code === splfare) {
                    element.isChecked = true;
                  } else {
                    element.isChecked = false;
                  }
                });

                this.setState({
                  faretypelist: tempOption,
                });
              }
            }
          }
        );
      }
    });

    await getAdvanceAirlineList().then((res) => {
      if (res?.data && res?.data?.data && res?.data?.data.length > 0) {
        airline = res?.data?.data?.map((ele, id) => {
          return {
            label: ele.name,
            value: ele.code,
            isChecked: false,
            displayValue: ele,
          };
        });
        airline.unshift({
          label: "All",
          value: "*",
          isChecked: false,
          displayValue: "All",
        });

        FlightDataCopy.forEach((element) => {
          let tempOptions = element.advancesearch.airlines;
          let temprdbOptions = JSON.parse(JSON.stringify(airline));
          for (let i = 0; i < temprdbOptions.length; i++) {
            // console.log(temprdbOptions[i].value, tempOptions);
            if (tempOptions.includes(temprdbOptions[i].value)) {
              temprdbOptions[i].isChecked = true;
            } else {
              temprdbOptions[i].isChecked = false;
            }
          }
          airline = temprdbOptions;
          element.advancesearch.airlines = JSON.parse(JSON.stringify(airline));
        });

        this.setState({
          FlightData: FlightDataCopy,
        });
      }
    });
    document.addEventListener("mousedown", this.handleClickOutside);
    this.bookingTypeComp();
    this.handleTripTypeSelection(this.props?.userProfile);
    if (this.props.isSRP) {
      this.bookingTypeMethod(Number(this.props.bookingType));
      this.setState({
        isguestChecked: this.props.isguestChecked === "true" ? true : false,
      });
    }
  }

  handleTripTypeSelection = (userData) => {
    if (userData?.type === "B2E") {
      const { corporate_detail } = userData;
      const tripTypes = this.state.TripType.map((item) => {
        if (item.id === 1) {
          item.show = corporate_detail?.et_details?.oneway || false;
        } else if (item.id === 2) {
          item.show = corporate_detail?.et_details?.roundtrip || false;
        } else if (item.id === 3) {
          item.show = corporate_detail?.et_details?.multicity || false;
        }
        return item;
      });

      this.setState({ TripType: tripTypes });
    }
  };

  bookingTypeComp = () => {
    checksession()
      .then((response) => {
        if (response.status) {
          this.setState({ userProfile: response });
          this.handleTripTypeSelection(response);
          let corporate_detail = response?.corporate_detail;
          if (corporate_detail?.et_details?.annual?.status) {
            this.state.bookingType.find(
              (item) => item.name === "annual"
            ).show = true;
          } else {
            this.state.bookingType.find(
              (item) => item.name === "annual"
            ).show = false;
          }
          if (corporate_detail?.et_details?.business?.status) {
            this.state.bookingType.find(
              (item) => item.name === "business"
            ).show = true;
          } else {
            this.state.bookingType.find(
              (item) => item.name === "business"
            ).show = false;
          }
          if (corporate_detail?.et_details?.personal?.status) {
            this.state.bookingType.find(
              (item) => item.name === "personal"
            ).show = true;
          } else {
            this.state.bookingType.find(
              (item) => item.name === "personal"
            ).show = false;
          }
          if (corporate_detail?.et_details?.exceptional?.status) {
            this.state.bookingType.find(
              (item) => item.name === "exceptional"
            ).show = true;
          } else {
            this.state.bookingType.find(
              (item) => item.name === "exceptional"
            ).show = false;
          }

          let filterTrip = this.state.bookingType.filter((item) => item.show);
          console.log("filterTrip==================", this.state.bookingType);
          if (this.state.bookingType.length > 0 && !this.props.isSRP) {
            let index = 0;
            let new_data = this.state.bookingType.map((res, i) => {
              if (res.show && index < 1) {
                index = index + 1;
                return {
                  ...res,
                  selected: true,
                };
              } else {
                return {
                  ...res,
                  selected: false,
                };
              }
            });
            this.setState({
              bookingType: new_data,
              bookingTypeId: new_data[0].tripId,
            });
            console.log("new_data============", new_data);
          }
        }
      })
      .catch((err) => {
        console.log(err.msg);
      });
  };
  bookingTypeMethod = (id) => {
    console.log("triptype log:this.props.bookingType==============", id);
    let bookingType = this.state.bookingType;
    console.log(
      "triptype log:this.state.bookingType",
      this.state.bookingType,
      "bookingType",
      bookingType
    );

    let newdata = bookingType.map((res, ind) => {
      console.log("triptype log:res.tripId===", res.tripId, "id===", id);
      if (res.tripId === id) {
        this.setState({ bookingTypeId: id });
        if (!this.props.isSRP) {
          this.setState({ pax: { adults: 1, child: 0, infants: 0 } });
        }
        return {
          ...res,
          selected: true,
        };
      } else {
        return {
          ...res,
          selected: false,
        };
      }
    });
    this.setState({
      bookingType: newdata,
      isguestChecked: false,
    });
    let fltData = JSON.parse(JSON.stringify(this.state.FlightData));
    fltData[0].error.colleagueError = "";
    fltData[0].error.passengerError = "";
    this.setState({ FlightData: fltData });
    this.colleguesPolicy(this.state.colleagueEtRule, newdata);
  };
  componentWillReceiveProps(nextProps) {
    console.log(
      "🚀 ~ file: index.js:288 ~ Theme1 ~ componentWillReceiveProps ~ nextProps:aarti",
      nextProps
    );
    if (
      this.props.isSRP &&
      this.props.fetchGuestDetails != nextProps.fetchGuestDetails
    ) {
      let trip = this.state.TripType.find(
        (ele) => ele.id == this.props.tripType
      );
      this.setState(
        {
          selectedTripType: trip.value,
          isAdvanceSearch: this.props.isAdvanceSearch,
          pax: this.props.pax,
          guest_id: this.props.guest_id || "",
          bookingTypeId: this.props.bookingType,
        },
        () => {
          if (
            this.state?.guest_id !== "" &&
            (this.props?.userProfile?.user_type == "TD" ||
              this.props?.userProfile?.user_type == "ADMIN") &&
            !this.state.isguestChecked
          ) {
            this.guestDetail([nextProps?.fetchGuestDetails]);
          }
        }
      );
    }
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  flexiBaggageHandler(index) {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index][`flexiBaggage`] =
      !FlightDataCopy[index][`flexiBaggage`];
    this.setState({ FlightData: FlightDataCopy });
  }

  // Autocomplete functions
  onclickFlightAutoComplete(type, i) {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[i][`${type}Value`] = "";
    FlightDataCopy[i][`${type}`] = "";
    FlightDataCopy[i].error[`${type}ErrMsg`] = "";
    this.setState({ FlightData: FlightDataCopy });
    console.log("🚀 3", FlightDataCopy);

    this.props.getAutoSuggestData(
      FlightDataCopy[i][`${type}Value`],
      type == "src" ? "departure" : "return",
      "click"
    );
    FlightDataCopy[i][`show${type}Dropdown`] = true;
    this.setState({ FlightData: FlightDataCopy });
    this.scrollCalendar();
  }
  onFocusInputFeild(type, i) {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    if (FlightDataCopy?.length !== i) {
      FlightDataCopy[i].error[`${type}ErrMsg`] = "";
      this.setState({ FlightData: FlightDataCopy });
    }
  }

  expandAutoComplete = (bool, type, index) => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index][`show${type}Dropdown`] = bool;
    console.log("🚀 2", FlightDataCopy);

    this.setState({ FlightData: FlightDataCopy });
  };

  autoCompleteLeftIcon = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="17">
        <path
          fill-rule="evenodd"
          fill="#01445F"
          d="M23.819 6.123 8.442 12.885a1.015 1.015 0 0 1-.331.07.93.93 0 0 1-.474-.152L.924 8.43c-.126-.475-.225-.595-.285-.736-.179-.415.013-.897 1.031-1.076l1.294-.819a.82.82 0 0 1 .682 0L8.414 8.96l4.689-2.67-6.46-3.581a.817.817 0 0 1-.376-.398c.583-.413.004-.897.417-1.08l2.253-.99a.79.79 0 0 1 .589-.029L19.64 3.401l2.327-1.282a2.296 2.296 0 0 1 1.807 0c1.75.676 1.754 3.292.045 4.004zm-.695-2.505a.67.67 0 0 0-.52 0L19.456 5.5c-.191.42.024-.393-.609-.04L9.305 1.857l-.389.443 6.456 3.053a.82.82 0 0 1 .221 1.294.996.996 0 0 1-.266.184L8.72 9.746a.866.866 0 0 1-.266.061c-.14.011-.281-.014.006-.074L3.278 7.441l.052.098 4.875 3.66 14.919-6.587a.54.54 0 0 0 .265-.266c.128.374.009-.601-.265-.728zM1.398 15.35h22.895a.818.818 0 0 1 0 1.637H1.398a.819.819 0 0 1 0-1.637z"
        ></path>
      </svg>
    );
  };

  onClickSetDepartureGoingToValue = (
    city,
    airPortCode,
    airPortName,
    type,
    index
  ) => {
    let FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));

    if (this.state.selectedTripType == "roundTrip") {
      let copyIndex = index == 0 ? 1 : 0;
      let copyType = type == "src" ? "dest" : "src";
      FlightDataCopy[copyIndex][`${copyType}Value`] =
        city + " - (" + airPortCode + ")";
      FlightDataCopy[copyIndex][`${copyType}`] = airPortCode;
      if (
        FlightDataCopy[copyIndex]["srcValue"] !=
          FlightDataCopy[copyIndex]["destValue"] &&
        FlightDataCopy[copyIndex]["srcValue"] != "" &&
        FlightDataCopy[copyIndex]["destValue"] != ""
      )
        FlightDataCopy[copyIndex]["error"]["destErrMsg"] = "";
    }
    FlightDataCopy[index][`${type}Value`] = city + " - (" + airPortCode + ")";
    FlightDataCopy[index][`${type}`] = airPortCode;
    FlightDataCopy[index][`show${type}Dropdown`] = false;
    console.log("1aarti", FlightDataCopy);

    if (
      this.state.selectedTripType == "Multicity" &&
      type == "dest" &&
      index < FlightDataCopy.length - 1
    ) {
      FlightDataCopy[index + 1][`srcValue`] = city + " - (" + airPortCode + ")";
      FlightDataCopy[index + 1][`src`] = airPortCode;
    }
    this.setState({ FlightData: FlightDataCopy }, () => {
      console.log(
        "🚀 ~ file: index.js:140 ~ FlightData[index]:",
        this.state.FlightData
      );
      // this.checkValidation(this.state);
    });
  };

  onChangeSetDepartureGoingToValue = (value, type, index) => {
    let FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index][`${type}Value`] = value;
    this.setState({ FlightData: FlightDataCopy }, () => {
      let FlightDataCopy1 = JSON.parse(JSON.stringify(this.state.FlightData));
      this.props.getAutoSuggestData(
        value.trim(),
        type == "src" ? "departure" : "return",
        value ? "change" : "click"
      );
      FlightDataCopy1[index][`show${type}Dropdown`] = true;
      console.log("🚀 4", FlightDataCopy1);
      this.setState({ FlightData: FlightDataCopy1 });
    });
  };
  // Autocomplete functions
  // calendar functions
  onChangeDepartureGoingDateValue = (value, type, index) => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index][`${type}Date`] = cf.getDateWithFormat(
      value,
      this?.props?.dateFormat
    );
    if (type == "return") {
      let dayDifference = differenceInCalendarDays(
        new Date(FlightDataCopy[index][`returnDate`]),
        new Date(value)
      );
      if (dayDifference < 0)
        FlightDataCopy[index][`returnDate`] = cf.getDateWithFormat(
          addDays(new Date(value), 7),
          this?.props?.dateFormat
        );
    }
    FlightDataCopy[index][`show${type}DateDropdown`] = false;
    let dayDifference = differenceInCalendarDays(
      new Date(FlightDataCopy[0][`returnDate`]),
      new Date(value)
    );

    if (
      type == "departure" &&
      dayDifference < 0 &&
      this.state.selectedTripType == "oneWay"
    ) {
      FlightDataCopy[0][`returnDate`] = cf.getDateWithFormat(
        addDays(new Date(value), 7),
        this?.props?.dateFormat
      );
    }
    if (this.state.selectedTripType == "roundTrip") {
      if (index == 1 && type == "departure")
        FlightDataCopy[0][`returnDate`] = cf.getDateWithFormat(
          value,
          this?.props?.dateFormat
        );

      FlightDataCopy[1][`disabledDate`] = cf.getDateWithFormat(
        new Date(value),
        this?.props?.dateFormat
      );

      let dayDifference = differenceInCalendarDays(
        new Date(FlightDataCopy[0][`returnDate`]),
        new Date(value)
      );
      if (index == 0 && type == "departure" && dayDifference < 0) {
        FlightDataCopy[0][`returnDate`] = cf.getDateWithFormat(
          addDays(new Date(value), 7),
          this?.props?.dateFormat
        );
        FlightDataCopy[1][`departureDate`] = cf.getDateWithFormat(
          addDays(new Date(value), 7),
          this?.props?.dateFormat
        );
      }

      if (index == 0 && type == "return")
        FlightDataCopy[1][`departureDate`] = cf.getDateWithFormat(
          value,
          this?.props?.dateFormat
        );
    }

    if (this.state.selectedTripType == "Multicity") {
      for (let i = index + 1; i < FlightDataCopy.length; i++) {
        let dayDifference = differenceInCalendarDays(
          new Date(FlightDataCopy[i][`departureDate`]),
          new Date(value)
        );
        if (dayDifference < 0)
          FlightDataCopy[i][`departureDate`] = cf.getDateWithFormat(
            addDays(new Date(value), 7),
            this?.props?.dateFormat
          );
        FlightDataCopy[i]["disabledDate"] = cf.getDateWithFormat(
          FlightDataCopy[i - 1][`departureDate`],
          this?.props?.dateFormat
        );
      }
    }
    this.setState({ FlightData: FlightDataCopy });
  };

  scrollCalendar = () => {
    // let el = document.getElementById(`calendar`)
    // if (el) {
    //   el.scrollIntoView({
    //     behavior: 'smooth',
    //     block: 'center',
    //   })
    // }
    if (!this.props.isSRP) {
      window.scrollTo({
        top: 110,
        behavior: "smooth", // Optional: smooth scrolling
      });
    }
  };

  calendarSvgIcon = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="17">
        <path
          fill-rule="evenodd"
          fill="#01445F"
          d="M23.819 6.123 8.442 12.885a1.015 1.015 0 0 1-.331.07.93.93 0 0 1-.474-.152L.924 8.43c-.126-.475-.225-.595-.285-.736-.179-.415.013-.897 1.031-1.076l1.294-.819a.82.82 0 0 1 .682 0L8.414 8.96l4.689-2.67-6.46-3.581a.817.817 0 0 1-.376-.398c.583-.413.004-.897.417-1.08l2.253-.99a.79.79 0 0 1 .589-.029L19.64 3.401l2.327-1.282a2.296 2.296 0 0 1 1.807 0c1.75.676 1.754 3.292.045 4.004zm-.695-2.505a.67.67 0 0 0-.52 0L19.456 5.5c-.191.42.024-.393-.609-.04L9.305 1.857l-.389.443 6.456 3.053a.82.82 0 0 1 .221 1.294.996.996 0 0 1-.266.184L8.72 9.746a.866.866 0 0 1-.266.061c-.14.011-.281-.014.006-.074L3.278 7.441l.052.098 4.875 3.66 14.919-6.587a.54.54 0 0 0 .265-.266c.128.374.009-.601-.265-.728zM1.398 15.35h22.895a.818.818 0 0 1 0 1.637H1.398a.819.819 0 0 1 0-1.637z"
        ></path>
      </svg>
    );
  };

  onchangeVisibility = (bool, type, index) => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index][`show${type}DateDropdown`] = bool;
    this.setState({ FlightData: FlightDataCopy });
    console.log("FlightDataCopy22", FlightDataCopy);
    this.scrollCalendar();
  };

  closeEnquiry() {
    this.setState({
      onLoadPopup: !this.state.onLoadPopup,
    });
  }

  onButtonEnquiry = () => {
    this.setState({ isLoading: true }, () => {
      console.log("aaaaaaaaaafgvfvf", this.state.FlightData, this.state.pax);

      let flightcopy = this.state.FlightData.map((ele, id) => {
        return {
          org: ele.src,
          dest: ele.dest,
          odt: ele.departureDate,
        };
      });
      console.log("🚀 ~ flightcopy ~ flightcopy:", flightcopy);

      let trip = this.state.TripType.find(
        (ele) => ele.value == this.state.selectedTripType
      );

      console.log("changess", this.props);

      let data = {
        site_id: this.props?.side_id || "",
        service_type: "flight",
        remark: "Specila request",
        service_data: {
          searchReq: {
            flightsearch: [...flightcopy],
            adult: this.state.pax.adults,
            child: this.state.pax.child,
            infant: this.state.pax.infants,
            cabinclass: this.state.travellerCabinClass?.id,
            currency: this.props?.userProfile?.agent_balance?.currency || "",
            site_id: this.props?.side_id || "",
            supplier: "",
            trip: trip.id,
            isInternational: false,
            isRoundTrip: false,
          },
        },
      };
      console.log("🚀 ~ onButtonEnquiry ~ data:", data);

      offlineCreateEnquiry(data)
        .then((res) => {
          console.log("🚀 ~ Theme1 ~ offlineCreateEnquiry ~ res: flight", res);

          this.setState({
            enquiry_id: res.enquiry_id,
            onLoadPopup: true,
            isLoading: false, // Stop loading after the enquiry is created
          });
        })
        .catch((error) => {
          console.error("Error creating enquiry:", error);
          this.setState({ isLoading: false }); // Stop loading in case of an error
        });
    });
  };

  onClickSearchFlightEnquiry = () => {
    let { isValid, data, EmployeeError } = this.checkValidation(this.state);
    console.log(
      "🚀 ~ file: index.js:550 ~ Theme1 ~ isValid:",
      isValid,
      this.state.FlightData,
      data
    );

    if (isValid) {
      this.setState({ isLoading: true }, () => {
        this.onButtonEnquiry();
      });
    } else {
      this.setState({ FlightData: data }, () => {
        console.log("aarti", this.state.FlightData);
      });
    }
  };

  crossIcon() {
    return (
      <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        width="30px"
        height="30px"
        viewBox="0 0 30 30"
        enable-background="new 0 0 30 30"
      >
        <g>
          <path
            fill="currentColor"
            d="M15.401,29.146c-7.616,0-13.813-6.196-13.813-13.813S7.785,1.521,15.401,1.521 c7.617,0,13.813,6.196,13.813,13.813S23.018,29.146,15.401,29.146z M15.401,2.521c-7.065,0-12.813,5.747-12.813,12.813 c0,7.064,5.748,12.813,12.813,12.813s12.813-5.748,12.813-12.813C28.214,8.268,22.466,2.521,15.401,2.521z"
          ></path>
        </g>
        <path
          fill="currentColor"
          d="M24.65,15.333c0,0.368-0.299,0.666-0.667,0.666H6.818c-0.368,0-0.667-0.298-0.667-0.666l0,0 c0-0.368,0.298-0.667,0.667-0.667h17.166C24.352,14.666,24.65,14.965,24.65,15.333L24.65,15.333z"
        ></path>
      </svg>
    );
  }

  // calendar functions

  onChangeCabinClassValue = (element, index) => {
    let FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    // FlightDataCopy[index]["advancesearch"]["cabinclass"] = element
    // FlightDataCopy[index]["advancesearch"]["fcs"] = JSON.parse(JSON.stringify(rbdClass))
    // FlightDataCopy[index]["advancesearch"]["showCabinClassList"] = false
    console.log(
      "🚀 ~ file: index.js:399 ~ Theme1 ~ FlightDataCopy: 1",
      FlightDataCopy
    );

    FlightDataCopy = FlightDataCopy.map((el, id) => {
      return {
        ...el,
        advancesearch: {
          ...el?.advancesearch,
          fcs: JSON.parse(JSON.stringify(rbdClass)),
          cabinclass:
            index == id
              ? element
              : el.advancesearch.cabinclass == {}
              ? { label: "Economy", id: 1 }
              : el.advancesearch.cabinclass,
          showCabinClassList:
            index == id ? false : el.advancesearch.showCabinClassList,
        },
        error: {
          ...el?.error,
          rbdCabinClassErrMsg: "",
          rbdCabinErrMsg: "",
        },
      };
    });

    this.setState({ FlightData: FlightDataCopy }, () => {
      console.log("this.state.FlightData", this.state.FlightData);
    });
  };

  onClickCabinClass = (index) => {
    console.log("hereee");
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy[index]["advancesearch"]["showCabinClassList"] =
      !FlightDataCopy[index]["advancesearch"]["showCabinClassList"];
    console.log(
      "🚀 ~ file: index.js:284 ~ Theme1 ~ FlightDataCopy[index]",
      FlightDataCopy[index]["showCabinClassList"]
    );
    this.setState({ FlightData: FlightDataCopy });
  };

  onClickChangePaxNumber = (pax, value, type) => {
    let paxCopy = JSON.parse(JSON.stringify(this.state.pax));
    if (pax === "adults") {
      if (
        +this.state.pax.child + value <= 9 &&
        +this.state.pax.child + value > 0
      ) {
        paxCopy.adults = value;
        if (type === "minus") {
          if (+this.state.pax.infants > value) {
            paxCopy.infants = +paxCopy.infants;
            --paxCopy.infants;
          }
        }
      }
    } else if (pax === "child") {
      if (
        +value + +this.state.pax.adults <= 9 &&
        +value + +this.state.pax.adults > 0
      )
        paxCopy.child = +value;
    } else if (pax === "infants") {
      if (value > +this.state.pax.adults) paxCopy.infants = +--value;
      else paxCopy.infants = +value;
    }
    if (Number(paxCopy.child) > 0 || Number(paxCopy.infants) > 0) {
      let farelist = this.state?.faretypelist.map((resfare, resind) => {
        return {
          ...resfare,
          isChecked: false,
        };
      });
      this.setState({
        faretypelist: farelist,
      });
    }
    console.log("paxCopy", paxCopy);
    let fltData = JSON.parse(JSON.stringify(this.state.FlightData));
    fltData[0].error.colleagueError = "";
    fltData[0].error.passengerError = "";
    this.setState({ pax: paxCopy, FlightData: fltData }, () => {
      console.log("aarti 3", this.state.pax);
    });
  };

  removeList(id) {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    FlightDataCopy.splice(id, 1);
    this.setState({ FlightData: FlightDataCopy }, () => {
      console.log("removeList", this.state.FlightData);
    });
  }

  AddFlightButton = () => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));

    let multiObj = {};

    if (FlightDataCopy[FlightDataCopy.length - 1].flight) {
      let previousFlight = FlightDataCopy[FlightDataCopy.length - 1];
      console.log(
        "🚀  file: index.js:353  Theme1 ~ previousFlight:",
        addDays(new Date(previousFlight?.departureDate), 1),
        this.props.dateFormat
      );
      if (FlightDataCopy.length <= 5) {
        multiObj = {
          ...multiObj,
          flight: previousFlight.flight + 1,
          src: previousFlight.dest,
          srcValue: previousFlight.destValue,
          dest: "",
          destValue: "",
          showsrcDropdown: false,
          showdestDropdown: false,
          departureDate: previousFlight.departureDate
            ? format(
                addDays(new Date(previousFlight?.departureDate), 1),
                "dd-MMM-yyyy"
              )
            : "",
          returnDate: previousFlight.returnDate
            ? format(
                addDays(new Date(previousFlight?.returnDate), 7),
                "dd-MMM-yyyy"
              )
            : "",
          showdepartureDateDropdown: false,
          showreturnDateDropdown: false,
          advancesearch: {
            airlines: JSON.parse(JSON.stringify(airline)),
            fcs: JSON.parse(JSON.stringify(rbdClass)),
            dtym: JSON.parse(JSON.stringify(DepartureTime)),
            cabinclass: Object.keys(previousFlight.advancesearch.cabinclass)
              .length
              ? { label: "Economy", id: 1 }
              : {},
            showCabinClassList: false,
          },
          flexiBaggage: true,
          bagreq: true,
          odt: previousFlight.departureDate
            ? format(new Date(previousFlight?.departureDate), "dd-MMM-yyyy")
            : format(Date.now(), this?.props?.dateFormat),
          disabledDate: previousFlight.departureDate
            ? format(new Date(previousFlight?.departureDate), "dd-MMM-yyyy")
            : format(Date.now(), this?.props?.dateFormat),
          error: {
            destErrMsg: "",
            srcErrMsg: "",
          },
        };
        FlightDataCopy.push(multiObj);
      }
    } else {
      multiObj = {
        ...multiObj,
        flight: 1,
        src: "",
        srcValue: org ? org : "",
        dest: "",
        destValue: "",
        showsrcDropdown: false,
        showdestDropdown: false,
        departureDate: format(new Date(), this?.props?.dateFormat),
        returnDate: format(addDays(new Date(), 7), this?.props?.dateFormat),
        showdepartureDateDropdown: false,
        showreturnDateDropdown: false,
        advancesearch: {
          airlines: JSON.parse(JSON.stringify(airline)),
          fcs: JSON.parse(JSON.stringify(rbdClass)),
          dtym: JSON.parse(JSON.stringify(DepartureTime)),
          cabinclass: { label: "Economy", id: 1 },
          showCabinClassList: false,
        },
        flexiBaggage: true,
        bagreq: true,
        odt: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
        disabledDate: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
        error: {
          destErrMsg: "",
          srcErrMsg: "",
        },
      };
      FlightDataCopy.push(multiObj);
    }

    console.log(
      "🚀  file: index.js:540  Theme1  this.setState  FlightDataCopy13:",
      FlightDataCopy
    );

    this.setState({ FlightData: FlightDataCopy }, () => {
      console.log(
        "🚀  file: index.js:534  Theme1  this.setState  FlightData:",
        this.state.FlightData
      );
    });
  };

  colleguesPolicy = (corporate_detail, selectedtrip) => {
    let bookingType = selectedtrip.filter((res) => res.selected);
    let newBookingType = [];
    newBookingType.push(corporate_detail?.et_details?.annual);
    newBookingType.push(corporate_detail?.et_details?.business);
    newBookingType.push(corporate_detail?.et_details?.exceptional);
    newBookingType.push(corporate_detail?.et_details?.personal);

    let bookingobj = newBookingType.filter(
      (res) => res?.id === Number(bookingType?.[0]?.tripId)
    );
    this.setState({
      etPolicy: bookingobj?.[0]?.policy_applicable == "yes" ? true : false,
    });
  };

  //Add client
  adGuestId = (id, corporate_detail) => {
    this.colleguesPolicy(corporate_detail, this.state.bookingType);
    this.setState({ guest_id: id }, () => {
      if (this.state.isError.selectedGuest === true) {
        this.validateErrorMsg();
      }
      let FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));

      FlightDataCopy = FlightDataCopy.map((el, id) => {
        return {
          ...el,
          error: {
            ...el?.error,
            colleagueError: "",
            bookingTypeError: "",
          },
        };
      });

      this.setState({
        guest_id: id,
        FlightData: FlightDataCopy,
        colleagueEtRule: corporate_detail,
      });
    });
  };
  guestDetail = (guestdetail) => {
    console.log("guestDetail-------------", guestdetail);
    console.log("bookingType===========", this?.props?.userProfile);
    if (guestdetail[0]?.corporate_detail?.et_details?.annual?.status) {
      this.state.guestBookingType.find(
        (item) => item.name === "annual"
      ).show = true;
    } else {
      this.state.guestBookingType.find(
        (item) => item.name === "annual"
      ).show = false;
    }
    if (guestdetail[0]?.corporate_detail?.et_details?.business?.status) {
      this.state.guestBookingType.find(
        (item) => item.name === "business"
      ).show = true;
    } else {
      this.state.guestBookingType.find(
        (item) => item.name === "business"
      ).show = false;
    }
    if (guestdetail[0]?.corporate_detail?.et_details?.personal?.status) {
      this.state.guestBookingType.find(
        (item) => item.name === "personal"
      ).show = true;
    } else {
      this.state.guestBookingType.find(
        (item) => item.name === "personal"
      ).show = false;
    }
    if (guestdetail[0]?.corporate_detail?.et_details?.exceptional?.status) {
      this.state.guestBookingType.find(
        (item) => item.name === "exceptional"
      ).show = true;
    } else {
      this.state.guestBookingType.find(
        (item) => item.name === "exceptional"
      ).show = false;
    }
    let filterTrip = this.state.guestBookingType.filter((item) => item.show);
    console.log("filterTrip==================", this.state.guestBookingType);
    if (this.state.guestBookingType.length > 0) {
      let index = 0;
      let new_data = this.state.guestBookingType.map((res, i) => {
        if (res.show && index < 1) {
          index = index + 1;
          return {
            ...res,
            selected: true,
          };
        } else {
          return {
            ...res,
            selected: false,
          };
        }
      });
      this.setState({
        guestBookingType: new_data,
        // bookingTypeId: new_data[0].tripId,
      });

      if (this.props?.userProfile?.type === "B2E") {
        if (guestdetail[0]?.corporate_detail?.et_details?.oneway) {
          this.state.guestTripType.find((item) => item.id === 1).show = true;
        } else {
          this.state.guestTripType.find((item) => item.id === 1).show = false;
        }
        if (guestdetail[0]?.corporate_detail?.et_details?.roundtrip) {
          this.state.guestTripType.find((item) => item.id === 2).show = true;
        } else {
          this.state.guestTripType.find((item) => item.id === 2).show = false;
        }
        if (guestdetail[0]?.corporate_detail?.et_details?.multicity) {
          this.state.guestTripType.find((item) => item.id === 3).show = true;
        } else {
          this.state.guestTripType.find((item) => item.id === 3).show = false;
        }
      }
      this.setState({
        guestTripType: this.state.guestTripType,
      });
    }
  };

  rmGuestId = () => {
    this.setState({ guest_id: "" });
    // this.bookingTypeComp();
  };

  // Add Employee Client

  addEmployeeGuestId = (item) => {
    let FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));

    FlightDataCopy = FlightDataCopy.map((el, id) => {
      return {
        ...el,
        error: {
          ...el?.error,
          colleagueError: "",
          bookingTypeError: "",
        },
      };
    });

    this.setState((prevState) => ({
      employeeguestId: [...prevState.employeeguestId, item],
      FlightData: FlightDataCopy,
    }));
  };

  removeEmployeeGuestId = (updatedId) => {
    this.setState({ employeeguestId: updatedId, colleagueEtRule: {} });
  };

  componentDidUpdate() {
    if (
      this.state.guest_id === "" &&
      this.props?.userProfile?.user_type === "CT"
    ) {
      this.setState({ guest_id: this.props?.userProfile?._id });
    }
    if (
      this.state.employeeguestId.length === 0 &&
      this.props?.userProfile?.user_type === "CT" &&
      !this.props.isSRP
    ) {
      this.setState({ employeeguestId: [this.props?.userProfile?._id] });
    }
  }

  handleClickOutside = () => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));

    if (this.state.openCabinClassList === true)
      this.setState({ openCabinClassList: false });
    if (this.state.expandDepartureBoolean === true)
      this.setState({ expandDepartureBoolean: false });
    if (this.state.expandGoingToBoolean === true)
      this.setState({ expandGoingToBoolean: false });
    if (
      this.guestDetailWrapper.current &&
      !this.guestDetailWrapper.current.contains(event.target)
    ) {
      this.setState({ openTraveler: false });
    }
    if (
      this.passengerDropdownWrapper.current &&
      !this.passengerDropdownWrapper.current.contains(event.target)
    ) {
      this.setState({ showTraveller: false });
    }

    if (
      this.travellerCabin.current &&
      !this.travellerCabin.current.contains(event.target)
    ) {
      this.setState({ travellerCabin: false });
    }

    if (
      this.departureListWrapper.current &&
      !this.departureListWrapper.current.contains(event.target)
    ) {
      let index = this.departureListWrapper.current.id
        ? this.departureListWrapper.current.id.split("_")[2]
        : "";

      FlightDataCopy[index]["showsrcDropdown"] = false;
    }

    if (
      this.returnListWrapper.current &&
      !this.returnListWrapper.current.contains(event.target)
    ) {
      let index = this.returnListWrapper.current.id
        ? this.returnListWrapper.current.id.split("_")[2]
        : "";

      FlightDataCopy[index]["showdestDropdown"] = false;
    }

    if (
      this.economyPopUpWrapper.current &&
      this.economyPopUpWrapper.current.length
    ) {
      this.economyPopUpWrapper.current.forEach((wrapper) => {
        if (!wrapper?.contains(event.target)) {
          let index = wrapper?.id ? parseInt(wrapper.id.split("_")[2]) : 0;
          FlightDataCopy[index]["advancesearch"]["showCabinClassList"] = false;
        }
      });
    }
    this.setState({ FlightData: FlightDataCopy });
  };
  onClickOpenCabinClassList = () => {
    // document.getElementById("modal_container-popup").scrollIntoView({ behavior: 'smooth', block: 'start' })
    if (this.state.openCabinClassList === false) {
      this.setState({ openCabinClassList: true });
    } else if (this.state.openCabinClassList === true) {
      this.setState({ openCabinClassList: false });
    }
  };

  checkValidation = (item) => {
    let isValid = true;
    // let totalPax = parseFloat(this.state.pax.adults) + parseFloat(this.state.pax.child) + parseFloat(this.state.pax.infants);
    let totalPax = parseFloat(this.state.pax.adults);
    let colleagueslength = parseFloat(this?.state?.employeeguestId?.length);
    console.log("totalPax", totalPax, colleagueslength);
    let bookingType = this.state.bookingType.filter((res) => res.selected);
    const { FlightData = [] } = item;
    console.log("FlightData==============****", JSON.stringify(FlightData));
    FlightData.forEach((data, index) => {
      console.log(
        "🚀 ~ file: index.js:456 ~ Theme1 ~ FlightData.forEach ~ data:",
        data
      );
      let errorObj = data.error || {};
      if (data["srcValue"] === "") {
        isValid = false;
        errorObj["srcErrMsg"] = "Please Enter Origin";
      }
      if (data["destValue"] === "") {
        isValid = false;
        errorObj["destErrMsg"] = "Please Enter Destination";
      }

      if (
        data["srcValue"] === data["destValue"] &&
        data["destValue"] !== "" &&
        data["srcValue"] !== ""
      ) {
        isValid = false;
        errorObj["destErrMsg"] = "Origin and destination cannot be same";
      }
      if (data["src"] == "" && data["srcValue"] !== "") {
        isValid = false;
        errorObj["srcErrMsg"] = "Please Enter Valid Origin";
      }
      if (data["dest"] == "" && data["destValue"] !== "") {
        isValid = false;
        errorObj["destErrMsg"] = "Please Enter Valid Destination";
      }

      if (this.state.selectedTripType == "roundTrip") {
        if (
          index !== FlightData.length - 1 &&
          data["srcValue"] === FlightData[index + 1]["srcValue"] &&
          data["destValue"] === FlightData[index + 1]["destValue"] &&
          data["destValue"] !== "" &&
          data["srcValue"] !== ""
        ) {
          isValid = false;
          errorObj["destErrMsg"] = "Origin and destination cannot be same";
          FlightData[index + 1].error.destErrMsg =
            "Origin and destination cannot be same";
        }
      }
      if (this.props?.userProfile?.userType === "B2E") {
        if (this.props?.userProfile?.user_type == "CT" && !this.props?.isSRP) {
          if (this.state.bookingTypeId == 1 || this.state.bookingTypeId == 4) {
            if (totalPax > colleagueslength) {
              isValid = false;
              errorObj["colleagueError"] = `Please Add ${
                totalPax - colleagueslength
              } More Traveler`;
            }
            if (totalPax < colleagueslength) {
              isValid = false;
              errorObj["passengerError"] = `Please Add ${
                colleagueslength - totalPax
              } More Passenger`;
            }
          }
        } else {
          if (
            this.state?.guest_id === "" &&
            (this.props?.userProfile?.user_type == "TD" ||
              this.props?.userProfile?.user_type == "ADMIN") &&
            !this.state.isguestChecked &&
            !this.props?.isSRP
          ) {
            console.log(
              "this.state.bookingTypeId===========",
              this.state.bookingTypeId
            );

            isValid = false;
            errorObj["colleagueError"] = "Please Select Traveler";
          } else if (
            this.state?.guest_id !== "" &&
            (this.props?.userProfile?.user_type == "TD" ||
              this.props?.userProfile?.user_type == "ADMIN") &&
            !this.state.isguestChecked
          ) {
            if (this.state.bookingTypeId != 4) {
              console.log(
                "this.state.bookingTypeId===========",
                this.state.bookingTypeId
              );
              let parentBookingTD = this.state.bookingType.filter(
                (res) => res.selected
              );
              let colleagueBookingTD = this.state.guestBookingType.filter(
                (res) => res.show
              );

              console.log(
                "a-------------",
                parentBookingTD,
                colleagueBookingTD
              );
              let isParentInColleague = parentBookingTD.some((parent) =>
                colleagueBookingTD.some(
                  (colleague) => colleague.tripId === parent.tripId
                )
              );
              if (!this.props.isSRP && !isParentInColleague && isValid) {
                isValid = false;
                this.setState({
                  showbookingTypeError: true,
                  modalPopupValue: "etRule",
                  showErrorMsg:
                    "Selected Trip Type is not allowed as per Employee policy",
                });
              }
            }
            let parentTripTD = this.state.selectedTripType;
            let colleagueTripTD = this.state.guestTripType.filter(
              (res) => res.show
            );
            let isParentTripInColleague = colleagueTripTD.some(
              (colleague) => colleague.value === parentTripTD
            );
            if (!isParentTripInColleague && isValid) {
              isValid = false;
              this.setState({
                showbookingTypeError: true,
                modalPopupValue: "etRule",
                showErrorMsg:
                  "Selected Journey Type is not allowed as per Employee policy",
              });
            }
          }
        }
      }
      console.log("lllllll", data.advancesearch);
      if (
        this.state.isAdvanceSearch &&
        Object?.keys(data["advancesearch"]["cabinclass"]).length === 0
      ) {
        if (!data["advancesearch"]["fcs"].some((el) => el?.isChecked)) {
          console.log(
            "weqe",
            !data["advancesearch"]["fcs"].some((el) => el?.isChecked)
          );
          isValid = false;
          errorObj["rbdCabinErrMsg"] = "Please Select RBD/ Class";
        } else {
          console.log(
            "weqef",
            !data["advancesearch"]["fcs"].some((el) => el?.isChecked)
          );
          errorObj["rbdCabinErrMsg"] = ""; // Reset the error message if criteria are met
        }

        //   if () {

        //     isValid = false
        //     errorObj['rbdCabinClassErrMsg'] = 'Please Select Cabin Class'
        //   }else {

        //     errorObj['rbdCabinClassErrMsg'] = ''; // Reset the error message if criteria are met
        //   }
      }

      // Object?.keys(data["advancesearch"]["cabinclass"]).length === 0
      data.error = errorObj;
      console.log("lllllllll", errorObj);
    });
    return { isValid, data: FlightData };
  };

  getSector = (data) => {
    let resp = data.map((element) => {
      console.log("datee aarti", element);
      let srcValue = element?.srcValue.split("-");
      console.log("srghgcValue", srcValue, srcValue[0].trim());

      let destValue = element?.destValue.split("-");
      if (element.advancesearch.dtym == "All") {
        element.advancesearch.dtym = "";
      }

      return {
        from: element?.src,
        to: element?.dest,
        fromcity: srcValue[0].trim(),
        tocity: destValue[0].trim(),
        date: format(new Date(element?.departureDate), "yyyy-MM-dd"),
        cabin: element.advancesearch?.cabinclass
          ? `${element.advancesearch?.cabinclass}`
          : 0,
        rbd: element.advancesearch?.fcs,
        airlines: element.advancesearch?.airlines,
        departuretime: element.advancesearch.dtym,
        flexibag: element.advancesearch.bagreq === true ? "1" : "0",
      };
    });
    console.log("gdataaaa", resp);

    return resp;
  };

  onClickSearchFlight = () => {
    let { isValid, data, EmployeeError } = this.checkValidation(this.state);

    if (isValid) {
      this.setState({ btnLoader: true }, () => {
        let updatedFlightData = this.state.FlightData.map((flightObj) => {
          return {
            ...flightObj,
            advancesearch: {
              airlines:
                flightObj.advancesearch.airlines &&
                flightObj.advancesearch.airlines
                  .filter((option) => option.isChecked)
                  .map((item) => item.value),
              fcs:
                flightObj.advancesearch.fcs &&
                flightObj.advancesearch.fcs
                  .filter((option) => option.isChecked)
                  .map((item) => item.value),
              dtym: flightObj.advancesearch.dtym
                .filter((option) => option.isChecked)
                .map((item) => item.code),
              cabinclass: this.state.isAdvanceSearch
                ? flightObj?.advancesearch?.cabinclass?.id
                : this.state.travellerCabinClass?.id,
            },
          };
        });

        let sectorRequest = this.getSector(updatedFlightData);
        let sector = getUrl(sectorRequest);
        let urseurl = parseurl(sector);

        let pax = Object.values(this.state.pax).map((value) => value);

        pax = pax.join("_");
        let supplier = this.props.selectedSupplier
          ? this.props.selectedSupplier
              .filter((option) => option.isChecked)
              .map((item) => item.value)
              .join("~")
          : [];
        let splfare = this.state?.faretypelist
          ? this.state?.faretypelist
              .filter((option) => option.isChecked)
              .map((item) => item.code)
          : "";

        let trip = this.state.TripType.find(
          (ele) => ele.value == this.state.selectedTripType
        );

        let bookingType = this.state.bookingType.filter((res) => res.selected);
        let urlQuery = {
          sector: sector,
          pax: pax,
          supplier: supplier,
          splfare: splfare,
          type: trip.id,
          isAdvanceSearch: this.state.isAdvanceSearch,
          guests: this.state?.guest_id,
          employeeGuest: this.state?.employeeguestId,
          bookingType: bookingType[0]?.tripId,
          guestCheck: this.state.isguestChecked,
          isModifySearch: this.props.isModifySearch || false,
          etPolicy: this.state.etPolicy,
        };
        localStorage.setItem("flight_srp", JSON.stringify(urlQuery));
        this.setState({ btnLoader: false });
        if (!this.props.isOffline) {
          cf.redirectTo("flight/search", urlQuery);
        } else {
          cf.redirectTo("/offlinesearch/flight", urlQuery);
        }
      });
    } else {
      this.setState({ FlightData: data, btnLoader: false }, () => {
        let scrollToId = this.scrollToError(this.state.FlightData);
        if (scrollToId) {
          scrollToId.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
        }
      });
    }
  };

  scrollToError = (data) => {
    let el = null;
    for (let index = 0; index < data.length; index++) {
      for (const key of Object.keys(data[index].error)) {
        if (key !== "") {
          el = document.getElementById(`${key}${index}`);
        }
        if (el) {
          break;
        }
      }
      if (el) {
        break;
      }
    }
    return el;
  };

  validateErrorMsg = () => {
    const mapDispatch = {
      departure: commonFunction.isValueEmpty(this.state.departureValue)
        ? true
        : false,
      goingTo: commonFunction.isValueEmpty(this.state.goingToValue)
        ? true
        : false,
      departureDate: commonFunction.isValueEmpty(this.state.departureDateValue)
        ? true
        : false,
      goingToDate: commonFunction.isValueEmpty(this.state.goingToDateValue)
        ? true
        : false,
      selectedGuest: cf.isValueEmpty(this.state.guest_id) ? true : false,
    };
    this.setState({ isError: mapDispatch });
  };
  onClickSwap = (index) => {
    console.log(
      "🚀 ~ file: index.js:823 ~ Theme1 ~ index:",
      index,
      this.state.FlightData
    );
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    const FlightDataCopy1 = JSON.parse(JSON.stringify(this.state.FlightData));

    FlightDataCopy[index]["src"] = FlightDataCopy1[index]["dest"];
    FlightDataCopy[index]["srcValue"] = FlightDataCopy1[index]["destValue"];
    FlightDataCopy[index]["dest"] = FlightDataCopy1[index]["src"];
    FlightDataCopy[index]["destValue"] = FlightDataCopy1[index]["srcValue"];
    FlightDataCopy[index]["error"]["srcErrMsg"] =
      FlightDataCopy[index]["srcValue"] == "" ? "Please Enter Origin" : "";
    // console.log(typeof(FlightDataCopy[index]["destValue"]),'FlightDataCopy[index]["destValue"]')
    FlightDataCopy[index]["error"]["destErrMsg"] =
      FlightDataCopy[index]["destValue"] == ""
        ? "Please Enter Destination"
        : "";
    if (
      FlightDataCopy[index]["srcValue"] == FlightDataCopy[index]["destValue"] &&
      FlightDataCopy[index]["srcValue"] != "" &&
      FlightDataCopy[index]["destValue"] != ""
    ) {
      FlightDataCopy[index]["error"]["destErrMsg"] =
        "Origin and destination cannot be same";
    } else {
      FlightDataCopy[index]["error"]["destErrMsg"] =
        FlightDataCopy[index]["destValue"] == ""
          ? "Please Enter Destination"
          : "";
    }
    if (
      !this.state.isAdvanceSearch &&
      this.state.selectedTripType == "roundTrip"
    ) {
      FlightDataCopy[index + 1]["src"] = FlightDataCopy1[index + 1]["dest"];
      FlightDataCopy[index + 1]["srcValue"] =
        FlightDataCopy1[index + 1]["destValue"];
      FlightDataCopy[index + 1]["dest"] = FlightDataCopy1[index + 1]["src"];
      FlightDataCopy[index + 1]["destValue"] =
        FlightDataCopy1[index + 1]["srcValue"];
      if (
        FlightDataCopy[index + 1]["srcValue"] ==
        FlightDataCopy[index + 1]["destValue"]
      )
        FlightDataCopy[index + 1]["destErrMsg"] =
          "Origin and destination cannot be same";
    }
    this.setState({ FlightData: FlightDataCopy }, () => {
      console.log(
        "🚀 ~ file: index.js:833 ~ Theme1 ~ this.setState ~ FlightData:",
        this.state.FlightData
      );
    });
  };

  onClickOpenPassangerList = () => {
    this.setState({ travellerCabin: !this.state.travellerCabin }, () => {
      if (this.state.travellerCabin && this.props.isMobile) {
        this.checkAvailableSpace();
      }
    });
  };
  checkAvailableSpace = () => {
    if (this.travellerCabin.current) {
      const rect = this.travellerCabin.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const spaceBelow = windowHeight - rect.bottom;
      const spaceAbove = rect.top;

      if (spaceBelow < rect.height) {
        this.setState({ showAbove: true });
      } else {
        this.setState({ showAbove: false });
      }
    }
  };

  onClickAirlines = () => {
    this.setState({ isAdvanceSearch: !this.state.isAdvanceSearch });
  };

  onselectTrip = (trip, id, type, closedDropdown = null) => {
    const FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));
    let flightArr = [];
    let flightObj = { ...FlightDataCopy[0] };
    let flightObjCopy = { ...FlightDataCopy[0] };

    if (trip.value == "roundTrip" || trip.value == "Multicity") {
      flightArr.push({ ...flightObj });
      flightArr.push({
        ...flightObj,
        dest: flightObjCopy.src,
        destValue: flightObjCopy.srcValue,
        srcValue: flightObjCopy.destValue,
        src: flightObjCopy.dest,
        departureDate: flightObjCopy.returnDate,
        returnDate: format(
          addDays(new Date(flightObjCopy.returnDate), 7),
          "dd-LLL-yyyy"
        ),
        flight: flightObj.flight + 1,
        disabledDate: flightArr[0]?.departureDate,
      });
    } else if (trip.value == "oneWay") {
      flightArr.push({ ...flightObj });
    } else {
      // flightArr.push({ ...flightObj });
      // flightArr.push({
      //   ...flightObj,
      //   disabledDate: flightArr[0].departureDate,
      // });
    }
    if (closedDropdown !== null) {
      flightArr[0][`show${type}DateDropdown`] = closedDropdown;
    }

    this.setState({ FlightData: flightArr });

    this.setState({
      selectedTripType: trip.value,
    });
    if (this.props.isSRP) {
      this.fetchGuestDetail();
    }
  };

  traveller = () => {
    console.log(
      "+this.state.pax.adults + +this.state.pax.child + +this.state.pax.infants",
      +this.state.pax.adults + +this.state.pax.child + +this.state.pax.infants
    );
    return (
      <div
        className={
          this.props.styles.flight_search_column +
          " " +
          this.props.styles.flight_search_class +
          " " +
          this.props.styles.wd_25
        }
      >
        <div
          className={`${this.props.styles.flight_cabin_class_cont} ${this.props.styles.trav_pd0}`}
          onClick={() => {
            this.setState({ showTraveller: !this.state.showTraveller });
          }}
        >
          <label>Traveller</label>
          <div className={this.props.styles.advTrav_flx}>
            <div className={this.props.styles.flight_travIcon}>
              <svg width="15px" height="15px" viewBox="0 0 200 200">
                <g>
                  <path
                    fill="#30C8CA"
                    d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                  ></path>
                </g>
              </svg>
            </div>
            <div
              className={`${this.props.styles.flight_cabin_class_nameAdvance} ${this.props.styles.flight_travler}`}
            >
              {`${
                +this.state.pax.adults +
                +this.state.pax.child +
                +this.state.pax.infants
              }`}
              &nbsp;Passenger
            </div>
          </div>
        </div>
        {this.state.showTraveller === true ? (
          <div
            className={this.props.styles.flight_search_pax_select_main}
            ref={this.passengerDropdownWrapper}
          >
            <div
              className={
                this.props.styles.flight_search_column +
                " " +
                this.props.styles.flight_search_pax
              }
            >
              <div className={this.props.styles.flight_search_pax_newleft}>
                <label>Adult</label>
                <span>(+12 Years)</span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.adults)
                    ? +this.state.pax.adults
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("adults", value, type)
                }
                maxLimit={9}
                minLimit={1}
                totalPax={+this.state.pax.child + +this.state.pax.adults}
                styles={this.props.styles}
              />
            </div>

            <div
              className={
                this.props.styles.flight_search_column +
                " " +
                this.props.styles.flight_search_pax
              }
            >
              <div className={this.props.styles.flight_search_pax_newleft}>
                <label>Children</label>
                <span>(2-11 Years)</span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.child)
                    ? +this.state.pax.child
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("child", value, type)
                }
                maxLimit={9}
                minLimit={0}
                totalPax={+this.state.pax.child + +this.state.pax.adults}
                styles={this.props.styles}
              />
            </div>

            <div
              className={
                this.props.styles.flight_search_column +
                " " +
                this.props.styles.flight_search_pax
              }
            >
              <div className={this.props.styles.flight_search_pax_newleft}>
                <label>Infant</label>
                <span>(Below 2 Years)</span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.infants)
                    ? +this.state.pax.infants
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("infants", value, type)
                }
                maxLimit={+this.state.pax.adults}
                minLimit={0}
                totalPax={+this.state.pax.infants}
                styles={this.props.styles}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  cabinClassEle = (ele, id) => {
    console.log("ele.cabinclass", ele, id);
    return (
      <div
        className={
          this.props.styles.flight_search_column +
          " " +
          this.props.styles.flight_search_class +
          " " +
          this.props.styles.wd_100
        }
        ref={(el) => {
          console.log("this.economyPopUpWrapper", this.economyPopUpWrapper);
          if (!this.economyPopUpWrapper.current)
            this.economyPopUpWrapper.current = [];
          return (this.economyPopUpWrapper.current[id] = el);
        }}
        id={`Flight_cabin_${parseInt(id)}`}
      >
        <div
          className={`${this.props.styles.flight_cabin_class_cont}`}
          // onClick={() => {this.onClickCabinClass(id)}}
        >
          <label>Cabin</label>

          <div
            className={this.props.styles.cabin_cont_flx}
            onClick={() => {
              this.onClickCabinClass(id);
            }}
          >
            <div className={this.props.styles.cabin_flx}>
              <div className={this.props.styles.flight_cabin_class_icon4}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18">
                  <path
                    fill-rule="evenodd"
                    fill="#005A95"
                    d="M12.767 15.73h-1.771v.523a1.18 1.18 0 0 1-1.18 1.181H.962v-1.181h8.854v-.523H4.785c-.534 0-1.002-1.016-1.14-1.532L1.43 4.471c-.724-1.259.023-2.554 1.283-2.891a2.36 2.36 0 0 1 2.891 1.669l1.9 7.103h5.158a2.432 2.432 0 0 1 2.454 2.124c.008.077.011.154.011.231.002 1.413-.407 3.003-2.36 3.023zm0-4.198h-6.17L4.464 3.555c-.169-.63-.816-1.004-1.284-.835-.792.169-1.04.816-.997 1.446l2.602 9.727h7.982a1.18 1.18 0 0 0 1.18-1.181c0-.102-.528-1.18-1.18-1.18zm.59-3.541a.885.885 0 1 1 0-1.77.885.885 0 0 1 0 1.77zm-.59-7.082h1.18V5.4h-1.18V.909z"
                  />
                </svg>
              </div>
              <div className={this.props.styles.flight_cabin_class_nameAdvance}>
                {!cf.isValueEmpty(ele.advancesearch.cabinclass)
                  ? ele.advancesearch.cabinclass.label
                  : ""}
              </div>
            </div>
            <div className={this.props.styles.flight_cabin_arrowMn}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8">
                <path
                  fill-rule="evenodd"
                  fill="#01445F"
                  d="M11.606.458c.704-.008 1.103.082 1.515.021a1.073 1.073 0 0 1-.021 1.517L7.746 7.198l-.747-.769.748.772a1.072 1.072 0 0 1-1.554-.061L.942 1.996A1.074 1.074 0 0 1 .921.479C1.334.54 2.12.45 2.437.458L7.2 4.931 11.606.458z"
                />
              </svg>
            </div>
          </div>

          {ele.advancesearch.showCabinClassList ? (
            <div className={this.props.styles.flight_cabin_class_list}>
              {cabinClass.map((element, index) => {
                return (
                  <label
                    key={"cabinClass" + index}
                    className={
                      this.props.styles.flight_cabin_class_ele +
                      " " +
                      this.props.styles.CabinLabel
                    }
                    onClick={() => {
                      this.onChangeCabinClassValue(element, id);
                    }}
                  >
                    <input
                      type="radio"
                      checked={
                        element.label === ele.advancesearch?.cabinclass?.label
                          ? true
                          : false
                      }
                    />
                    <span className={this.props.styles.classTitle}>
                      {element.label}
                    </span>
                  </label>
                );
              })}
            </div>
          ) : null}
        </div>
        {ele.error.rbdCabinErrMsg ? (
          <span className={this.props.styles.rbderr}>
            {/* {ele.error.rbdCabinErrMsg} */}
            {"Please Select Cabin"}
          </span>
        ) : null}
      </div>
    );
  };

  RBDClassDropdown = (index) => {
    const { FlightData } = this.state;
    const options = FlightData[index]?.advancesearch?.fcs;
    console.log("🚀 ~ file: index.js:830 ~ options:", options);

    return (
      <>
        <MultiSelectDropDown
          style={this.props.styles}
          inputPlaceHolder={"Select RBD Class"}
          dropdownInputPlaceHolder={"Type here RBD"}
          options={options}
          setoptions={(newOptions) => {
            console.log(
              "🚀 ~ file: index.js:1129 ~ Theme1 ~ newOptions:",
              newOptions,
              index
            );

            let updatedData = JSON.parse(JSON.stringify(FlightData));
            console.log(
              "🚀 ~ file: index.js:1130 ~ Theme1 ~ updatedData:",
              updatedData
            );

            updatedData = updatedData.map((el, id) => {
              console.log("el", el);
              return {
                ...el,
                advancesearch: {
                  ...el?.advancesearch,
                  fcs: index == id ? newOptions : el.advancesearch.fcs,
                  cabinclass: {},
                },
                error: {
                  ...el?.error,
                  rbdCabinErrMsg: "",
                },
              };
            });
            this.setState({ FlightData: updatedData }, () => {
              console.log(
                "🚀 ~ file: index.js:1130 ~ Theme1 ~ updaghhtedData:",
                this.state.FlightData
              );
            });
          }}
        />
      </>
    );
  };

  AirlineClassDropdown = (index) => {
    const { FlightData } = this.state;
    const options = FlightData[index]?.advancesearch?.airlines;

    return (
      <>
        <MultiSelectDropDown
          style={this.props.styles}
          inputPlaceHolder={"Select Airline"}
          dropdownInputPlaceHolder={"Type here Airline"}
          options={options}
          setoptions={(newOptions) => {
            const updatedData = JSON.parse(JSON.stringify(FlightData));
            updatedData[index] = {
              ...updatedData[index],
              advancesearch: {
                ...updatedData[index]?.advancesearch,
                airlines: newOptions,
              },
            };
            this.setState({ FlightData: updatedData });
          }}
        />
      </>
    );
  };

  onClickTraveller = () => {
    if (!this.state.openTraveler) {
      this.setState({ openTraveler: true });
    } else {
      this.setState({ openTraveler: false });
    }
  };

  DepartureTimeDropdown = (index) => {
    const { FlightData } = this.state;
    let departureOption = FlightData[index]?.advancesearch?.dtym;
    return (
      <>
        <MultiSuppilerDropDownoption
          options={departureOption}
          setoptions={(newOptions) => {
            const updatedData = JSON.parse(JSON.stringify(FlightData));
            updatedData[index] = {
              ...updatedData[index],
              advancesearch: {
                ...updatedData[index]?.advancesearch,
                dtym: newOptions,
              },
            };
            this.setState({ FlightData: updatedData }, () => {
              this.setState({
                FlightData: this.state.FlightData,
              });
            });
          }}
          inputPlaceHolder={"Departure Time"}
          style={this.props.styles}
          box={this.box}
        />
      </>
    );
  };

  travellerCabinEleMobile = () => {
    console.log(
      "vbvbbvbcc",
      +this.state.pax.adults + +this.state.pax.child + +this.state.pax.infants,
      this.state.travellerCabinClass.label
    );

    return (
      <>
        <div
          className={
            this.props.styles.mob_flight_search_column +
            " " +
            this.props.styles.mob_flight_search_pax
          }
          onClick={() => this.onClickOpenPassangerList()}
        >
          <div className={this.props.styles.flight_trav_title}>
            {" "}
            Traveler | Class
          </div>
          <div className={this.props.styles.flight_cabin_class_name}>
            <span>
              <svg width="20px" height="20px" viewBox="0 0 200 200">
                <g>
                  <path
                    fill="#30C8CA"
                    d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                  ></path>
                </g>
              </svg>
            </span>
            {`${
              +this.state.pax.adults +
              +this.state.pax.child +
              +this.state.pax.infants
            } Passenger, ${this.state.travellerCabinClass.label}`}
          </div>

          <div
            className={this.props.styles.flight_cabin_class_arrow_pass}
          ></div>
        </div>

        {this.state.travellerCabin ? (
          <div
            className={this.props.styles.flighttraveller_dropNorm}
            ref={this.travellerCabin}
          >
            <div className={this.props.styles.flighttraveller_drop_flex}>
              <div className={this.props.styles.flighttraveller_drop_adult}>
                <label>Adult(s)</label>
                <span>(12 yrs & above)</span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.adults)
                    ? +this.state.pax.adults
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("adults", value, type)
                }
                maxLimit={9}
                minLimit={1}
                totalPax={+this.state.pax.child + +this.state.pax.adults}
                styles={this.props.styles}
              />
            </div>

            <div className={this.props.styles.flighttraveller_drop_flex}>
              <div className={this.props.styles.flighttraveller_drop_adult}>
                <label>Children(s)</label>
                <span>(2-12 yrs)</span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.child)
                    ? +this.state.pax.child
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("child", value, type)
                }
                maxLimit={9}
                minLimit={0}
                totalPax={+this.state.pax.child + +this.state.pax.adults}
                styles={this.props.styles}
              />
            </div>

            <div className={this.props.styles.flighttraveller_drop_flex}>
              <div className={this.props.styles.flighttraveller_drop_adult}>
                <label>Infant(s)</label>
                <span>(below 2 yrs)</span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.infants)
                    ? +this.state.pax.infants
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("infants", value, type)
                }
                maxLimit={+this.state.pax.adults}
                minLimit={0}
                totalPax={this.state.pax.infants}
                styles={this.props.styles}
              />
            </div>

            <div
              className={`${this.props?.styles?.flight_pax_title} ${this.props?.styles?.cabin_class_sec}`}
            >
              Cabin Class
            </div>
            {
              <div
                // ref={this.economyPopUpWrapper}
                className={this.props?.styles?.flight_cabin_class_list_them}
              >
                {cabinClass.map((element, index) => {
                  return (
                    <div className={this.props?.styles?.flight_cabin_bxd}>
                      <input
                        type="radio"
                        className={this.props?.styles?.pax_input}
                        checked={
                          element.label === this.state.travellerCabinClass.label
                        }
                        onClick={() => {
                          this.setState({
                            travellerCabinClass: element,
                          });
                        }}
                        id={element.label}
                        value={element.label}
                      />
                      <label>{element.label} </label>
                    </div>
                  );
                })}
              </div>
            }

            <div className={this.props.styles.pax_btn_thme}>
              <button
                onClick={() => {
                  this.onClickOpenPassangerList();
                }}
              >
                {" "}
                Done
              </button>
            </div>
          </div>
        ) : null}
      </>
    );
  };

  travellerCabinEle = () => {
    let showChildInfant = true;
    if (this.props?.userProfile?.userType === "B2E") {
      showChildInfant =
        (Number(this.state.bookingTypeId) === 4 &&
          !this.state.isguestChecked) ||
        Number(this.state.bookingTypeId) === 1
          ? false
          : true;
    }
    const { showAbove, travellerCabin } = this.state;
    const dropdownPosition = !this.props.isMobile
      ? "below"
      : this.props.isMobile && showAbove
      ? "above"
      : "below";
    return (
      <>
        <div className={this.props.styles.trav_mainCont}>
          <div
            className={`${this.props.styles.flight_search_column} ${this.props.styles.flight_cabin_class_cont} ${this.props.styles.wd_25}  ${this.props.styles.pd_10}`}
            onClick={() => this.onClickOpenPassangerList()}
          >
            <div className={`${this.props.styles.flight_trav_title}`}>
              {" "}
              Traveler & Class
            </div>
            <div className={this.props.styles.trave_flx}>
              <div className={this.props.styles.icon_box_adv}>
                <svg width="15px" height="15px" viewBox="0 0 200 200">
                  <g>
                    <path
                      fill="#30C8CA"
                      d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                    ></path>
                  </g>
                </svg>
              </div>
              <div className={this.props.styles.flt_pasngrFlx}>
                <span className={this.props.styles.flight_cabin_class_name}>
                  {`${
                    +this.state.pax.adults +
                    +this.state.pax.child +
                    +this.state.pax.infants
                  } Passenger`}
                </span>
                {!this.state.isAdvanceSearch && (
                  <span className={this.props.styles.flt_trav_label}>
                    {`: ${this.state.travellerCabinClass?.label}`}
                  </span>
                )}
              </div>
            </div>
            {this.state.FlightData[0].error.passengerError !== "" && (
              <div
                className={`${this.props.styles.flight_search_error_message} ${this.props.styles.flight_search_error_message_pax}`}
              >
                <span>{this.state.FlightData[0].error.passengerError}</span>
              </div>
            )}
          </div>

          {this.state.travellerCabin ? (
            <div
              className={`${
                this.props.styles.flight_search_Pax_main +
                " " +
                this.props.styles.flight_search_pax_select_main
              } ${
                dropdownPosition === "above"
                  ? this.props.styles.dropdown_above
                  : ""
              }`}
              ref={this.travellerCabin}
            >
              <div className={this.props.styles.flight_pax_title}>Traveler</div>
              <div
                className={
                  // this.this.props.styles.flight_search_column +
                  // " " +
                  this.props.styles.flight_search_pax
                }
              >
                <div className={this.props.styles.flight_search_pax_newleft}>
                  <label>Adult(s)</label>
                  <span>(12 yrs & above)</span>
                </div>
                <PaxConfig
                  value={
                    !cf.isValueEmpty(this.state.pax.adults)
                      ? this.state.pax.adults
                      : 0
                  }
                  onChangePaxValue={(value, type) =>
                    this.onClickChangePaxNumber("adults", value, type)
                  }
                  maxLimit={9}
                  minLimit={1}
                  totalPax={+this.state.pax.child + +this.state.pax.adults}
                  styles={this.props.styles}
                />
              </div>
              {showChildInfant && (
                <>
                  <div className={this.props.styles.flight_search_pax}>
                    <div
                      className={this.props.styles.flight_search_pax_newleft}
                    >
                      <label>Children(s)</label>
                      <span>(2-12 yrs)</span>
                    </div>
                    <PaxConfig
                      value={
                        !cf.isValueEmpty(this.state.pax.child)
                          ? this.state.pax.child
                          : 0
                      }
                      onChangePaxValue={(value, type) =>
                        this.onClickChangePaxNumber("child", value, type)
                      }
                      maxLimit={9}
                      minLimit={0}
                      totalPax={+this.state.pax.child + +this.state.pax.adults}
                      styles={this.props.styles}
                    />
                  </div>

                  <div className={this.props.styles.flight_search_pax}>
                    <div
                      className={this.props.styles.flight_search_pax_newleft}
                    >
                      <label>Infant(s)</label>
                      <span>(below 2 yrs)</span>
                    </div>
                    <PaxConfig
                      value={
                        !cf.isValueEmpty(this.state.pax.infants)
                          ? this.state.pax.infants
                          : 0
                      }
                      onChangePaxValue={(value, type) =>
                        this.onClickChangePaxNumber("infants", value, type)
                      }
                      maxLimit={+this.state.pax.adults}
                      minLimit={0}
                      totalPax={this.state.pax.infants}
                      styles={this.props.styles}
                    />
                  </div>
                </>
              )}
              {!this.state.isAdvanceSearch && (
                <>
                  <div
                    className={`${this.props.styles.flight_pax_title} ${this.props.styles.cabin_class_sec}`}
                  >
                    Cabin Class
                  </div>
                  {
                    <div
                      // ref={this.economyPopUpWrapper}
                      className={
                        this.props?.styles?.flight_cabin_class_list_them
                      }
                    >
                      {cabinClass.map((element, index) => {
                        return (
                          <div
                            className={`${this.props?.styles?.flight_cabin_bxd} ${this.props.styles.active_way}`}
                            onClick={() => {
                              this.setState({
                                travellerCabinClass: element,
                              });
                            }}
                          >
                            <input
                              type="radio"
                              className={this.props?.styles?.pax_input}
                              checked={
                                element.label ===
                                this.state.travellerCabinClass?.label
                              }
                              id={element.label}
                              value={element.label}
                            />
                            <label>{element.label} </label>
                          </div>
                        );
                      })}
                    </div>
                  }
                </>
              )}
              <div className={this.props.styles.pax_btn_thme}>
                <button
                  onClick={() => {
                    this.onClickOpenPassangerList();
                  }}
                >
                  {" "}
                  Done
                </button>
              </div>
            </div>
          ) : null}
        </div>
      </>
    );
  };

  traveller = () => {
    return (
      <div
        className={`${this.props.styles.advn_box} ${this.props.styles.mrgn_top}`}
      >
        <div
          className={this.props.styles.advLbl}
          onClick={() => {
            this.setState({ showTraveller: !this.state.showTraveller });
          }}
        >
          <label>Traveller</label>
          <div className={this.props.styles.travMn_flx}>
            <div className={this.props.styles.inner_rbdIcon}>
              <svg width="20px" height="20px" viewBox="0 0 200 200">
                <g>
                  <path
                    fill="#01445f"
                    d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                  ></path>
                </g>
              </svg>
            </div>
            <div className={this.props.styles.inner_passng}>
              {`${
                +this.state.pax.adults +
                +this.state.pax.child +
                +this.state.pax.infants
              }`}
              &nbsp;Passenger
            </div>
          </div>
        </div>
        {this.state.showTraveller === true ? (
          <div
            className={this.props.styles.flighttraveller_drop}
            ref={this.passengerDropdownWrapper}
          >
            <div className={this.props.styles.flighttraveller_drop_flex}>
              <div className={this.props.styles.flighttraveller_drop_adult}>
                <label>Adult</label>
                <span>(+12 Years)</span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.adults)
                    ? +this.state.pax.adults
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("adults", value, type)
                }
                maxLimit={9}
                minLimit={1}
                totalPax={+this.state.pax.child + +this.state.pax.adults}
                styles={this.props.styles}
              />
            </div>

            <div className={this.props.styles.flighttraveller_drop_flex}>
              <div className={this.props.styles.flighttraveller_drop_adult}>
                <label>Children</label>
                <span>(2-11 Years)</span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.child)
                    ? +this.state.pax.child
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("child", value, type)
                }
                maxLimit={9}
                minLimit={0}
                totalPax={+this.state.pax.child + +this.state.pax.adults}
                styles={this.props.styles}
              />
            </div>

            <div className={this.props.styles.flighttraveller_drop_flex}>
              <div className={this.props.styles.flighttraveller_drop_adult}>
                <label>Infant</label>
                <span>(Below 2 Years)</span>
              </div>
              <PaxConfig
                value={
                  !cf.isValueEmpty(this.state.pax.infants)
                    ? +this.state.pax.infants
                    : 0
                }
                onChangePaxValue={(value, type) =>
                  this.onClickChangePaxNumber("infants", value, type)
                }
                maxLimit={+this.state.pax.adults}
                minLimit={0}
                totalPax={+this.state.pax.infants}
                styles={this.props.styles}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  handleGuestCheckbox = () => {
    this.setState({ isguestChecked: !this.state.isguestChecked }, () => {
      console.log("a----------------", this.state.isguestChecked);
    });
    // !this.state.isguestChecked &&this.bookingTypeComp()
    let FlightDataCopy = JSON.parse(JSON.stringify(this.state.FlightData));

    FlightDataCopy = FlightDataCopy.map((el, id) => {
      return {
        ...el,
        error: {
          ...el?.error,
          colleagueError: "",
        },
      };
    });

    this.setState({ FlightData: FlightDataCopy });
  };

  modalPopupSwitch = () => {
    switch (this.state.modalPopupValue) {
      case "etRule":
        return (
          <div className={this.props.styles.enquiy_container}>
            <div className={this.props.styles.send_success}>
              {/* <img src="theme4/tick.png" alt="send quote" /> */}
              {/* <div className={this.props.styles.send_lbl}>Send Enquiry</div> */}
            </div>
            <div className={this.props.styles.enquire_wrap}>
              <span className={this.props.styles.quote_lblTitle}>
                {/* Enquiry ID: {this.state?.enquiry_id} */}
              </span>
            </div>
            <span className={this.props.styles.quote_success}>
              {this.state.showErrorMsg}
            </span>
            <div className={this.props.styles.btn_container}>
              <button
                className={this.props.styles.ok_button}
                onClick={() => {
                  // this.onButtonEnquiry()
                  this.setState({
                    showbookingTypeError: false,
                  });
                }}
              >
                OK
              </button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };
  handleOnClickFareType = (data, index) => {
    console.log("handleOnClickFareType", data, index);
    let farelist = this.state?.faretypelist.map((resfare, resind) => {
      if (resind == index) {
        return {
          ...resfare,
          isChecked: !resfare?.isChecked,
        };
      } else {
        return {
          ...resfare,
          isChecked: false,
        };
      }
    });
    this.setState({
      faretypelist: farelist,
    });
  };

  fetchGuestDetail = () => {
    if (
      this.state?.guest_id !== "" &&
      (this.props?.userProfile?.user_type == "TD" ||
        this.props?.userProfile?.user_type == "ADMIN") &&
      !this.state.isguestChecked
    ) {
      this.guestDetail([this?.props?.fetchGuestDetails]);
    }
    // }
  };
  render() {
    return (
      <>
        <div
          className={`${
            this.props.isMobile
              ? this.props.styles.mob_flight_search_wid_container
              : this.props.isSRP
              ? this.props.styles.srpwidget
              : "container mx-auto xl:px-8"
          } ${this.props.isMobile ? this.props.styles.srpwidget : ""}
          ${this.props?.isOffline ? this.props.styles.Offlinewidget : ""}`}
          ref={this.setDropdownWrapperRef}
        >
          <div
            className={
              this.props.isMobile
                ? this.props.styles.mob_flight_search_wid_main
                : this.props.isSRP
                ? this.props.styles.srpwidget_wrap
                : this.props.styles.flight_search_wid_container
            }
          >
            {this.props.isMobile ? (
              <div
                className={
                  this.props.isMobile
                    ? this.props.styles.tab_submenu_content_srp
                    : !this.props.isMobile && this.props.isSRP
                    ? this.props.hide
                    : ""
                }
                id={this.props.styles.tab_submenu_content}
              >
                <div
                  className={
                    this.props.styles.landing_tab_submenu_new +
                    " " +
                    this.props.styles.sub_tab_new
                  }
                >
                  <div className={this.props.styles.mobile_visible}>
                    <div
                      className={
                        this.props.styles.mobo_tab_header +
                        " " +
                        this.props.styles.flight_header_mobo
                      }
                    >
                      {/* <img src="/images/back-arrow.png" alt="" className={this.props.styles.arrow_image} onClick={() => this.props.onClosePopup(false)} /> */}
                      <span
                        className={this.props.styles.arrow_image}
                        onClick={() => {
                          if (this.props.isSRP) {
                            this.props.onClosePopup(false);
                          } else {
                            window.location.href = "/";
                          }
                        }}
                      >
                        {/* <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                                        </svg> */}
                        <svg
                          version="1.1"
                          id="Layer_1"
                          x="0px"
                          y="0px"
                          width="200px"
                          height="200px"
                          viewBox="0 0 200 200"
                          stroke="currentColor"
                        >
                          <g>
                            <g>
                              <path
                                fill="currentColor"
                                d="M94.277,181.169c-3.199,0-6.398-1.22-8.839-3.661L16.77,108.839c-4.881-4.882-4.881-12.796,0-17.678    l68.668-68.668c4.882-4.882,12.797-4.882,17.678,0c4.882,4.881,4.882,12.796,0,17.678L43.287,100l59.83,59.83    c4.882,4.882,4.882,12.796,0,17.678C100.676,179.948,97.476,181.169,94.277,181.169z"
                              ></path>
                            </g>
                            <g>
                              <path
                                fill="currentColor"
                                d="M174.391,112.5H35.146c-6.903,0-12.5-5.597-12.5-12.5s5.597-12.5,12.5-12.5h139.245    c6.903,0,12.5,5.597,12.5,12.5S181.294,112.5,174.391,112.5z"
                              ></path>
                            </g>
                          </g>
                        </svg>
                      </span>
                      <h3 className={this.props.styles.search_filter_header}>
                        Flights
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            <div
              className={`${this.props.styles.flight_mobile_widget} flight_search_wid_main`}
            >
              <div className={this.props.styles.flight_way_tab}>
                <div className={this.props.styles.flight_way_btngrp}>
                  {/* flight tabs trip */}
                  <div className={this.props.styles.trip_type_container}>
                    {this.props?.userProfile?.userType === "B2E" &&
                      !this.props.isSRP && (
                        <>
                          <span className={this.props.styles.trip_type_heading}>
                            Trip Type :
                          </span>
                          {this.state.bookingType.length > 0 &&
                            this.state.bookingType.map((fact, id) => {
                              return (
                                <>
                                  {fact.show && (
                                    <span
                                      className={
                                        this.props.styles.trip_radio_group
                                      }
                                    >
                                      <input
                                        type="radio"
                                        name={fact.name}
                                        value={fact.value}
                                        label={fact.label}
                                        checked={fact.selected}
                                        onClick={() => {
                                          this.bookingTypeMethod(fact.tripId);
                                        }}
                                      />
                                      {fact.label}
                                    </span>
                                  )}
                                </>
                              );
                            })}
                        </>
                      )}
                  </div>

                  {this.state.TripType.map((trip, id) => {
                    return (
                      <>
                        {trip.show && (
                          <button
                            className={
                              trip.value === this.state.selectedTripType
                                ? this.props.styles.active_way
                                : this.props.styles.button_style
                            }
                            onClick={() => {
                              this.onselectTrip(trip, id);
                            }}
                          >
                            <input
                              type="radio"
                              value={trip.value}
                              checked={
                                trip.value === this.state.selectedTripType
                              }
                            />
                            <label>{trip.label}</label>
                          </button>
                        )}
                      </>
                    );
                  })}

                  {/* flight tabs trip end */}

                  {/* b2b flow adanvance search */}

                  {this.props?.offlineType !== "Enquiry" ? (
                    <div className={this.props.styles.flightBtobflx}>
                      <B2BWidgets
                        theme="theme4"
                        isMobile={this.props?.isMobile}
                        type="flight"
                        styles={this.props.b2bStyles}
                        {...this.state}
                        onClickAirlines={this.onClickAirlines}
                        listWrapper={this.advanceSearchWrapper}
                        guestWrapper={this.guestDetailWrapper}
                        isOffline={this.props.isOffline}
                        errorMessage={"Select Traveler"}
                        openAirlines={this.state.isAdvanceSearch}
                        onClickTraveller={this.onClickTraveller}
                        applyb2bFilters={this.applyb2bFilters}
                        addGuestId={this.adGuestId}
                        guestDetail={this.guestDetail}
                        addEmployeeGuestId={this.addEmployeeGuestId}
                        removeEmployeeGuestId={this.removeEmployeeGuestId}
                        removeGuestId={this.rmGuestId}
                        handleOnChangeAirlines={this.handleOnChangeAirlines}
                        handleStopCheck={this.handleStopCheck}
                        isError={this.state.isError.selectedGuest}
                        isSRP={this.props.isSRP || false}
                        guestText={"Add Client(s)"}
                        userProfile={
                          this.props.isSRP
                            ? this.state.userProfile
                            : this.props?.userProfile
                        }
                        guestChecked={this.state.isguestChecked}
                        bookingTypeId={this.state.bookingTypeId}
                        handleGuestCheckbox={this.handleGuestCheckbox}
                        isguestChecked={this.state.isguestChecked}
                        totalPax={
                          +this.state.pax.adults +
                          +this.state.pax.child +
                          +this.state.pax.infants
                        }
                        employeeguestIdList={
                          this.props.isSRP ? this.props.employeeguestIdList : []
                        }
                        getGuest={this.props.state}
                      />
                    </div>
                  ) : null}

                  {/* b2b flow adanvance search end */}
                </div>
              </div>

              <div
                // id={this.props.isMobile ? "modal_container-popup" : ""}
                className={
                  !this.props.mobile
                    ? this.props.styles.flight_search_details_container
                    : this.props.styles.mob_flight_search_details_container
                }
              >
                {this.state.FlightData[0].error.colleagueError !== "" && (
                  <div
                    className={this.props.styles.flight_colleage_error_message}
                    id={"colleagueError0"}
                  >
                    {this.state.FlightData[0].error.colleagueError}
                  </div>
                )}
                <div
                  className={`${this.props.styles.flight_search_details_main} ${
                    this.props.isMobile
                      ? this.props.styles.mob_flight_search_details_main
                      : this.props.styles.flight_search_details_main
                  }`}
                >
                  {this.state.FlightData &&
                    this.state.FlightData.map((ele, id) => {
                      // console.log("🚀 ~ ele766666666666:", ele, id)
                      if (
                        this.state.selectedTripType === "roundTrip" &&
                        id == 1 &&
                        this.state.isAdvanceSearch === false
                      ) {
                        return <></>;
                      }
                      return (
                        <>
                          <div
                            className={
                              this.state.isAdvanceSearch
                                ? this.props.styles.advance_flx
                                : ""
                            }
                          >
                            <div
                              className={`${
                                this.props.styles.flight_search_details_row
                              }
                            ${
                              this.props.isMobile
                                ? this.props.styles
                                    .mob_flight_search_details_row
                                : this.props.styles.flight_search_details_row
                            }`}
                            >
                              <div
                                className={`${
                                  this.props.isMobile
                                    ? this.props.styles.mob_flight_search_column
                                    : this.props.styles.flight_search_column
                                } ${
                                  this.props.isMobile
                                    ? this.props.styles.mob_flight_search_depart
                                    : this.props.styles
                                        .flight_search_depart_multicity
                                } `}
                                id={"srcErrMsg" + id}
                              >
                                <FlightAutoComplete
                                  label="From"
                                  value={ele.srcValue}
                                  onclickFlightAutoComplete={() =>
                                    this.onclickFlightAutoComplete("src", id)
                                  }
                                  styles={this.props.styles}
                                  state={this.state}
                                  placholder={
                                    this.props.isMobile
                                      ? "Where are you going?"
                                      : "Please Enter Origin"
                                  }
                                  onClickSourceAndDestination={(
                                    airPortCode,
                                    city,
                                    airPortName
                                  ) =>
                                    this.onClickSetDepartureGoingToValue(
                                      airPortCode,
                                      city,
                                      airPortName,
                                      "src",
                                      id
                                    )
                                  }
                                  onChangeSourceAndDestination={(value) =>
                                    this.onChangeSetDepartureGoingToValue(
                                      value,
                                      "src",
                                      id
                                    )
                                  }
                                  isAutoCompleteExpand={(bool) => {
                                    this.expandAutoComplete(bool, "src", id);
                                  }}
                                  autoCompleteData={
                                    this.props.getDepartureSuggestionList || []
                                  }
                                  expandAutoCompleteBool={
                                    ele.showsrcDropdown || false
                                  }
                                  leftIcon={
                                    <svg width="26" height="17">
                                      <path
                                        fill-rule="evenodd"
                                        fill="#01445F"
                                        d="M23.819 6.123 8.442 12.885a1.015 1.015 0 0 1-.331.07.93.93 0 0 1-.474-.152L.924 8.43c-.126-.475-.225-.595-.285-.736-.179-.415.013-.897 1.031-1.076l1.294-.819a.82.82 0 0 1 .682 0L8.414 8.96l4.689-2.67-6.46-3.581a.817.817 0 0 1-.376-.398c.583-.413.004-.897.417-1.08l2.253-.99a.79.79 0 0 1 .589-.029L19.64 3.401l2.327-1.282a2.296 2.296 0 0 1 1.807 0c1.75.676 1.754 3.292.045 4.004zm-.695-2.505a.67.67 0 0 0-.52 0L19.456 5.5c-.191.42.024-.393-.609-.04L9.305 1.857l-.389.443 6.456 3.053a.82.82 0 0 1 .221 1.294.996.996 0 0 1-.266.184L8.72 9.746a.866.866 0 0 1-.266.061c-.14.011-.281-.014.006-.074L3.278 7.441l.052.098 4.875 3.66 14.919-6.587a.54.54 0 0 0 .265-.266c.128.374.009-.601-.265-.728zM1.398 15.35h22.895a.818.818 0 0 1 0 1.637H1.398a.819.819 0 0 1 0-1.637z"
                                      ></path>
                                    </svg>
                                  }
                                  errorMessage={ele.error.srcErrMsg}
                                  isError={ele.error.srcErrMsg ? true : false}
                                  listWrapper={this.departureListWrapper}
                                  id={id}
                                  onFocusInput={() =>
                                    this.onFocusInputFeild("dest", id + 1)
                                  }
                                  // onFocus={(e) => {
                                  //   // e.stopPropagation()
                                  //   onFocusInput("src",id)
                                  //   setshowtitle(false)
                                  //   // formTitleHandler(formTitle.value)
                                  // }}
                                />
                              </div>
                              <span
                                className={
                                  this.props.isSRP
                                    ? this.props.styles.srpwidget_Advance
                                    : this.props.styles.srpwidget_nrml
                                }
                              >
                                <span
                                  className={`${
                                    this.props.styles.flight_swapAdv
                                  }
                                ${
                                  this.state.selectedTripType === "oneWay" &&
                                  !this.state?.TripType[1]?.show
                                    ? this.props.styles.flight_newoneway_swap
                                    : ""
                                }
                            ${
                              this.state.selectedTripType === "oneWay"
                                ? this.props.styles.flight_oneway
                                : ""
                            }
                            ${
                              this.state.isAdvanceSearch
                                ? this.props.styles.flight_onewayAdvance
                                : ""
                            }

                          ${
                            this.state.selectedTripType === "roundTrip"
                              ? this.props.styles.flight_roundTrip
                              : ""
                          }
                          ${
                            this.state.selectedTripType === "Multicity"
                              ? this.props.styles.flight_multicity
                              : ""
                          }`}
                                  tabIndex="2"
                                  onKeyDown={this.props.onSwapKeyDownHandler}
                                  onClick={() => {
                                    this.onClickSwap(id);
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="32"
                                    version="1.1"
                                    id="Layer_1"
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 33 33"
                                  >
                                    <g>
                                      <path
                                        class="st0"
                                        d="M16.5,32.2c-8.7,0-15.7-7-15.7-15.7s7-15.7,15.7-15.7s15.7,7,15.7,15.7S25.1,32.2,16.5,32.2z M16.5,1.8   C8.4,1.8,1.8,8.4,1.8,16.5c0,8.1,6.6,14.7,14.7,14.7c8.1,0,14.7-6.6,14.7-14.7C31.2,8.4,24.6,1.8,16.5,1.8z"
                                      ></path>
                                    </g>
                                    <polygon
                                      class="st1"
                                      points="25.6,22.3 25.6,22.3 25.6,22.3 "
                                    ></polygon>
                                    <g>
                                      <path
                                        class="st0"
                                        d="M26.9,15.9c0.3-0.3,0.4-1.2,0-1.5l-5.5-5.5c-0.3-0.3-0.9-0.3-1.2,0C20.1,9,20,9.2,20,9.4   c0,0.2,0.1,0.4,0.2,0.6l4.2,4.2l-17.8,0c-0.5,0-0.8,0.4-0.8,0.8l0,0c0,0.5,0.4,0.8,0.8,0.8h17.6"
                                      ></path>
                                      <path
                                        class="st0"
                                        d="M6.1,17.1c-0.3,0.3-0.4,1.2,0,1.5l5.5,5.5c0.3,0.3,0.9,0.3,1.2,0c0.2-0.2,0.2-0.4,0.2-0.6   c0-0.2-0.1-0.4-0.2-0.6l-4.2-4.2l17.8,0c0.5,0,0.8-0.4,0.8-0.8l0,0c0-0.5-0.4-0.8-0.8-0.8H8.8"
                                      ></path>
                                    </g>
                                  </svg>
                                </span>
                              </span>
                              <div
                                // className={
                                //   this.props.styles.flight_search_column +
                                //   " " +
                                //   this.props.styles.flight_search_depart_multicity
                                // }

                                className={`${
                                  this.props.isMobile
                                    ? this.props.styles.mob_flight_search_column
                                    : this.props.styles.flight_search_column
                                } ${
                                  this.props.isMobile
                                    ? this.props.styles.mob_flight_search_depart
                                    : this.props.styles
                                        .flight_search_depart_multicity
                                } `}
                                id={"destErrMsg" + id}
                              >
                                <FlightAutoComplete
                                  label="To"
                                  value={ele.destValue}
                                  onclickFlightAutoComplete={() =>
                                    this.onclickFlightAutoComplete("dest", id)
                                  }
                                  styles={this.props.styles}
                                  state={this.state}
                                  placholder={
                                    this.props.isMobile
                                      ? "Where are you going?"
                                      : "Please Enter Destination"
                                  }
                                  onClickSourceAndDestination={(
                                    city,
                                    airPortCode,
                                    airPortName
                                  ) =>
                                    this.onClickSetDepartureGoingToValue(
                                      city,
                                      airPortCode,
                                      airPortName,
                                      "dest",
                                      id
                                    )
                                  }
                                  onChangeSourceAndDestination={(value) =>
                                    this.onChangeSetDepartureGoingToValue(
                                      value,
                                      "dest",
                                      id
                                    )
                                  }
                                  isAutoCompleteExpand={(bool) => {
                                    this.expandAutoComplete(bool, "dest", id);
                                  }}
                                  autoCompleteData={
                                    this.props.getGoingToSuggestionList || []
                                  }
                                  expandAutoCompleteBool={
                                    ele.showdestDropdown || false
                                  }
                                  leftIcon={
                                    <svg width="26" height="19">
                                      <path
                                        fill-rule="evenodd"
                                        fill="#01445F"
                                        d="M24.293 18.987H1.398a.819.819 0 0 1 0-1.637h22.895a.818.818 0 0 1 0 1.637zm-2.001-4.807L5.715 11.466a1.031 1.031 0 0 1-.316-.122c-.137-.098-.246-.231.441-.386L2.52 3.307c-.526-.141-.543-.197-.22-.447.5-.446.203-.745.649-.669l2.036.348a.823.823 0 0 1 .573.372l2.744 4.524 5.058.824-3.605-6.305a.819.819 0 0 1 .84-1.216l2.635.397c-.005.03.177.137.302.297l6.258 7.874 3.132.508c.619.107 1.958.463 1.515.985 1.099 1.521-.324 3.716-2.145 3.381zm1.458-2.479c-.776-.149-.933-.251-1.11-.283l-3.396-.553c.116-.032-.397-.137-.533-.298L12.45 2.692l-.14-.068 3.321 6.306c.039.068.068.79.086.219.105.439-.167 1.151-.607.986.29.021-.215.024-.323.009L7.66 8.986a.872.872 0 0 1-.257-.094.815.815 0 0 1-.302-.284L4.354 4.87l.596-.52 1.485 5.573 16.098 2.612a.553.553 0 0 0 .368-.078c.256-.161.335-.499.849-.756z"
                                      ></path>
                                    </svg>
                                  }
                                  errorMessage={ele.error.destErrMsg}
                                  // errorMessage={((ele.destValue.length && ele.srcValue.length) && (ele.srcValue === ele.destValue)) ? "Origin and destination cannot be same" : "Please enter destination city"}
                                  isError={ele.error.destErrMsg ? true : false}
                                  // airPortName={this.state.goingToAirPortName}
                                  listWrapper={this.returnListWrapper}
                                  id={id}
                                  onFocusInput={() =>
                                    this.onFocusInputFeild("src", id + 1)
                                  }
                                />
                              </div>

                              {this.props.isMobile ? (
                                <div
                                  className={
                                    this.props.styles.mob_flight_search_column +
                                    " " +
                                    this.props.styles
                                      .mob_flight_search_depart_going_date
                                  }
                                >
                                  <MobileCalender
                                    label="Departure"
                                    styles={this.props.styles}
                                    value={ele.departureDate || ""}
                                    placholder="Departure Date"
                                    onChangeDate={(value) => {
                                      this.onChangeDepartureGoingDateValue(
                                        value,
                                        "departure",
                                        id
                                      );
                                    }}
                                    startDate={ele.departureDate || ""}
                                    endDate={ele.returnDate || ""}
                                    startDateLimit={ele.disabledDate || ""}
                                    dateFormat={"DD-MMM-YYYY"}
                                    changeVisibility={(bool) => {
                                      this.onchangeVisibility(
                                        bool,
                                        "departure",
                                        id
                                      );
                                    }}
                                    isVisible={ele.showdepartureDateDropdown}
                                    type={"double"}
                                    doubleSelection={false}
                                    totalMonths={13}
                                    DisableReturnDate={
                                      this.state.selectedTripType == "oneWay"
                                    }
                                    iconImage={
                                      <svg width="19" height="19">
                                        <path
                                          fill-rule="evenodd"
                                          fill="#01445F"
                                          d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.84V3.149c0 .161-.48-.225-.882-.304a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.59.627.967v13.507c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627C.153 17.374 0 17.32 0 16.655V3.149c0-.377.153-.719.401-.967.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.304v3.498zm16.922.94H.938v9.068c0 .117.049.224.702.304-.498.401-.391.891-.272.891h15.288c.118 0 .225-.49.304-.891.42-.078.9-.185.9-.304V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"
                                        ></path>
                                      </svg>
                                    }
                                  />
                                  {/* <svg xmlns="http://www.w3.org/2000/svg" className={this.props.styles.modify_icons}><path fill-rule="evenodd" fill="#01445F" d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.84V3.149c0 .161-.48-.225-.882-.304a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.59.627.967v13.507c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627C.153 17.374 0 17.32 0 16.655V3.149c0-.377.153-.719.401-.967.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.304v3.498zm16.922.94H.938v9.068c0 .117.049.224.702.304-.498.401-.391.891-.272.891h15.288c.118 0 .225-.49.304-.891.42-.078.9-.185.9-.304V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"></path></svg> */}
                                </div>
                              ) : (
                                <div
                                  className={
                                    this.props.styles.flight_search_column +
                                    " " +
                                    this.props.styles
                                      .flight_search_depart_going_date
                                    // +
                                    // " " +
                                    // this.props.styles.wd_40
                                  }
                                  id={"calendar"}
                                >
                                  <DesktopCalender
                                    label="Departure"
                                    styles={this.props.styles}
                                    value={ele.departureDate || ""}
                                    isdepartureDateValue={true}
                                    departureDate={ele.departureDate}
                                    onChangeDate={(value) => {
                                      this.onChangeDepartureGoingDateValue(
                                        value,
                                        "departure",
                                        id
                                      );
                                    }}
                                    iconImage={
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="19"
                                        height="19"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          fill="#01445F"
                                          d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.84V3.149c0 .161-.48-.225-.882-.304a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.59.627.967v13.507c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627C.153 17.374 0 17.32 0 16.655V3.149c0-.377.153-.719.401-.967.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.304v3.498zm16.922.94H.938v9.068c0 .117.049.224.702.304-.498.401-.391.891-.272.891h15.288c.118 0 .225-.49.304-.891.42-.078.9-.185.9-.304V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"
                                        ></path>
                                      </svg>
                                    }
                                    startDate={todaysDate || ""}
                                    endDate={ele.returnDate || ""}
                                    startDateLimit={ele.disabledDate || ""}
                                    dateFormat={"DD-MMM-YYYY"}
                                    changeVisibility={(bool) => {
                                      this.onchangeVisibility(
                                        bool,
                                        "departure",
                                        id
                                      );
                                    }}
                                    isVisible={ele.showdepartureDateDropdown}
                                    type={"double"}
                                    doubleSelection={false}
                                  />
                                </div>
                              )}

                              {this.state.selectedTripType === "Multicity" &&
                              !this.state.isAdvanceSearch &&
                              id > 1 ? (
                                <div
                                  className={
                                    this.props.styles.remove_flight_buttonMulti
                                  }
                                  style={{
                                    display: "flex",
                                    justifyContent: "end",
                                  }}
                                  id="decrease"
                                  onClick={() => {
                                    this.removeList(id);
                                  }}
                                >
                                  {this.crossIcon()}
                                </div>
                              ) : null}

                              {this.props.isMobile ? (
                                <>
                                  {this.state.selectedTripType ===
                                    "roundTrip" &&
                                  this.state.isAdvanceSearch === false ? (
                                    <div
                                      className={
                                        this.props.styles
                                          .mob_flight_search_column +
                                        " " +
                                        this.props.styles
                                          .mob_flight_search_depart_going_date
                                      }
                                    >
                                      <MobileCalender
                                        label="Return"
                                        styles={this.props.styles}
                                        value={ele.returnDate || ""}
                                        placholder="Arrival Date"
                                        onChangeDate={(value) => {
                                          this.onChangeDepartureGoingDateValue(
                                            value,
                                            "return",
                                            id
                                          );
                                        }}
                                        startDate={ele.departureDate || ""}
                                        endDate={ele.returnDate || ""}
                                        startDateLimit={
                                          ele.departureDate
                                            ? ele.departureDate
                                            : ele.disabledDate
                                            ? ele.disabledDate
                                            : todaysDate
                                        }
                                        dateFormat={"DD-MMM-YYYY"}
                                        changeVisibility={(bool) => {
                                          this.onchangeVisibility(
                                            bool,
                                            "return",
                                            id
                                          );
                                        }}
                                        isVisible={ele.showreturnDateDropdown}
                                        type={"double"}
                                        doubleSelection={false}
                                        totalMonths={13}
                                        DisableReturnDate={
                                          this.state.selectedTripType ==
                                          "oneWay"
                                        }
                                        iconImage={
                                          <svg width="19" height="19">
                                            <path
                                              fill-rule="evenodd"
                                              fill="#01445F"
                                              d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.84V3.149c0 .161-.48-.225-.882-.304a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.59.627.967v13.507c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627C.153 17.374 0 17.32 0 16.655V3.149c0-.377.153-.719.401-.967.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.304v3.498zm16.922.94H.938v9.068c0 .117.049.224.702.304-.498.401-.391.891-.272.891h15.288c.118 0 .225-.49.304-.891.42-.078.9-.185.9-.304V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"
                                            ></path>
                                          </svg>
                                        }
                                        // selectTripbtn={()=>{this.onselectTrip({ id: 2, value: "roundTrip", label: 'Round Trip'})}}
                                      />
                                    </div>
                                  ) : null}
                                </>
                              ) : (
                                <>
                                  {this.state.selectedTripType !==
                                    "Multicity" &&
                                  this.state.isAdvanceSearch === false ? (
                                    <div
                                      className={
                                        this.state?.TripType[1]?.show
                                          ? this.props.styles
                                              .flight_search_column +
                                            " " +
                                            this.props.styles
                                              .flight_search_depart_going_date
                                          : this.props.styles.hide
                                      }
                                      id={"calendar"}
                                    >
                                      <DesktopCalender
                                        label="Return"
                                        styles={this.props.styles}
                                        value={ele.returnDate || ""}
                                        isgoingToDateValue={true}
                                        departureDate={ele.returnDate}
                                        onChangeDate={(value) => {
                                          this.onChangeDepartureGoingDateValue(
                                            value,
                                            "return",
                                            id
                                          );
                                        }}
                                        iconImage={
                                          <svg
                                            width="19"
                                            height="19"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              fill-rule="evenodd"
                                              fill="#01445F"
                                              d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.84V3.149c0 .161-.48-.225-.882-.304a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.59.627.967v13.507c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627C.153 17.374 0 17.32 0 16.655V3.149c0-.377.153-.719.401-.967.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.304v3.498zm16.922.94H.938v9.068c0 .117.049.224.702.304-.498.401-.391.891-.272.891h15.288c.118 0 .225-.49.304-.891.42-.078.9-.185.9-.304V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"
                                            ></path>
                                          </svg>
                                        }
                                        startDate={ele.departureDate || ""}
                                        endDate={ele.returnDate || ""}
                                        startDateLimit={
                                          ele.departureDate
                                            ? ele.departureDate
                                            : ele.disabledDate
                                            ? ele.disabledDate
                                            : todaysDate
                                        }
                                        // startDateLimit={ele.disabledDate || ""}

                                        dateFormat={"DD-MMM-YYYY"}
                                        changeVisibility={(bool) => {
                                          this.onchangeVisibility(
                                            bool,
                                            "return",
                                            id
                                          );
                                        }}
                                        isVisible={ele.showreturnDateDropdown}
                                        type={"double"}
                                        doubleSelection={false}
                                        DisableReturnDate={
                                          this.state.selectedTripType ==
                                          "oneWay"
                                        }
                                        triptype={this.state.selectedTripType}
                                        selectTripbtn={() => {
                                          this.onselectTrip({
                                            id: 2,
                                            value: "roundTrip",
                                            label: "Round Trip",
                                          });
                                        }}
                                        roundWayReturnClick={() => {
                                          this.onselectTrip(
                                            {
                                              id: 1,
                                              value: "oneWay",
                                              label: "One Way",
                                            },
                                            id
                                          );
                                        }}
                                        showCrossIcon={
                                          this.state.selectedTripType ==
                                          "roundTrip"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  ) : null}
                                </>
                              )}
                            </div>
                            <div
                              className={this.props.styles.advance_container}
                            >
                              {this.state.isAdvanceSearch ? (
                                <div
                                  className={`${this.props.styles.adv_tabs_split} ${this.props.styles.wd_33}`}
                                  id={"rbdCabinErrMsg" + id}
                                >
                                  <div
                                    className={`${this.props.styles.departure_main_box} ${this.props.styles.wd_100}`}
                                  >
                                    <div
                                      className={this.props.styles.label_fname}
                                    >
                                      <label
                                        htmlFor="fname"
                                        className={
                                          this.props.styles.label_nameAdv
                                        }
                                      >
                                        RBD/Class
                                      </label>
                                    </div>
                                    <div
                                      //  onClick={()=>{props?.onRbDClickMulti(index)}}
                                      className={
                                        this.props.styles.icon_Rbd_advInputnw
                                      }
                                    >
                                      <div
                                        className={
                                          this.props.styles.icon_box_adv
                                        }
                                      >
                                        <svg
                                          width="15px"
                                          height="15px"
                                          viewBox="0 0 200 200"
                                        >
                                          <g>
                                            <path
                                              fill="#30C8CA"
                                              d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                                            ></path>
                                          </g>
                                        </svg>
                                      </div>
                                      {this.RBDClassDropdown(id)}
                                    </div>
                                    {ele.error.rbdCabinErrMsg ? (
                                      <span
                                        className={this.props.styles.rbderr}
                                      >
                                        {ele.error.rbdCabinErrMsg}
                                      </span>
                                    ) : null}
                                  </div>
                                </div>
                              ) : null}

                              {this.state.isAdvanceSearch ? (
                                <div
                                  className={`${this.props.styles.adv_tabs_split} ${this.props.styles.wd_33}`}
                                >
                                  {this.cabinClassEle(ele, id)}
                                </div>
                              ) : null}

                              {this.state.isAdvanceSearch &&
                              ((this.state.selectedTripType === "roundTrip" &&
                                id == 1) ||
                                this.state.selectedTripType != "roundTrip") ? (
                                <div
                                  className={`${
                                    !this.props.isMobile
                                      ? this.props.styles.adv_tabs_split
                                      : this.props.styles.advn_box
                                  } ${this.props.styles.wd_33}`}
                                >
                                  <div
                                    className={`${this.props.styles.departure_main_box} ${this.props.styles.wd_100}`}
                                  >
                                    <div
                                      className={this.props.styles.label_fname}
                                    >
                                      <label
                                        htmlFor="fname"
                                        className={
                                          this.props.styles.label_nameAdv
                                        }
                                      >
                                        Airlines
                                      </label>
                                    </div>

                                    <div
                                      className={`${this.props.styles.icon_Multicity_advInput} ${this.props.styles.icon_Rbd_advInputnw}`}
                                    >
                                      <div
                                        className={
                                          this.props.styles.icon_box_adv
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="18"
                                          height="13"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            fill="#01445F"
                                            d="m.924 8.43 6.713 4.373a.93.93 0 0 0 .474.152 1.02 1.02 0 0 0 .331-.07l15.377-6.762c1.709-.712 1.705-3.328-.045-4.004a2.296 2.296 0 0 0-1.807 0L19.64 3.401 9.526.212a.79.79 0 0 0-.589.029l-2.253.99c-.413.183.166.667-.417 1.08a.822.822 0 0 0 .376.398l6.46 3.581-4.689 2.67-4.768-3.161a.82.82 0 0 0-.682 0l-1.294.819C.652 6.797.46 7.278.639 7.694c.06.14.159.261.285.736zm2.354-.989L8.45 9.733c-.277.06-.136.085.004.074a.866.866 0 0 0 .266-.061l6.607-2.915a1.02 1.02 0 0 0 .266-.184.82.82 0 0 0-.221-1.294L8.916 2.29l.389-.433 9.542 3.603c.633-.353.418.46.609.04l3.148-1.882a.67.67 0 0 1 .52 0c.274.127.393 1.102.265.728a.54.54 0 0 1-.265.266L8.205 11.199 3.33 7.539l-.052-.098z"
                                          ></path>
                                        </svg>
                                      </div>
                                      {this.AirlineClassDropdown(id)}
                                    </div>
                                  </div>
                                </div>
                              ) : null}

                              {this.state.isAdvanceSearch ? (
                                <div
                                  className={`${
                                    this.props.isMobile
                                      ? this.props.styles.advn_box
                                      : this.props.styles.adv_tabs_split
                                  } ${this.props.styles.adv_tabs_splitDepart} ${
                                    this.props.styles.wd_33
                                  }`}
                                >
                                  <div
                                    className={`${`${this.props.styles.departure_main_box} ${this.props.styles.wd_100}`} ${
                                      this.props.styles.wd_100
                                    }`}
                                  >
                                    <div
                                      className={this.props.styles.label_fname}
                                    >
                                      <label
                                        htmlFor="fname"
                                        className={
                                          this.props.styles.label_nameAdv
                                        }
                                      >
                                        Departure Time
                                      </label>
                                    </div>
                                    <div
                                      className={`${this.props.styles.icon_Multicitydep_advInput} ${this.props.styles.icon_Rbd_advInputnw}`}
                                    >
                                      <div
                                        className={
                                          this.props.styles.icon_box_adv
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="19"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            fill="#01445F"
                                            d="M7.668 18.778H1.577c-.42 0-.761-.341-.761-.608 0-.574.341-.915.761-.915h6.091c1.212 0 .761.341.761.915 0 .267.451.608-.761.608zm-1.523-3.047H1.577a.762.762 0 0 1 0-1.523h4.568a.76.76 0 1 1 0 1.523zm-1.523-3.047H1.577a.762.762 0 0 1 0-1.524h3.045c.808 0 .762.341.762.762s.046.762-.762.762zm6.091 6.06c-.42.019-.776-.307-.795-.584-.019-.564.307-.921.727-.939a7.618 7.618 0 0 0 6.888-8.281c-.383-4.19-4.088-7.276-8.275-6.47C5.6 2.382 2.703 5.283 2.37 8.943a.762.762 0 1 1-1.517-.137C1.309 3.778 5.751.71 10.776.527c4.709.427 9.124 4.378 9.104 9.11-.768 4.736-4.382 8.698-9.098 9.104a.814.814 0 0 1-.069.003zM9.952 5.66c-.421 0-.762-.253-.762.167v3.81c0 .202.081.683.223.538l2.284 2.286a.761.761 0 0 0 1.077-.019c.816-.295.816-.763 0-1.059l-2.061-2.062V5.827c0-.42-.341-.167-.761-.167z"
                                          ></path>
                                        </svg>
                                      </div>
                                      {this.DepartureTimeDropdown(id)}
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                              {/* remove multi data */}

                              {this.state.selectedTripType === "Multicity" &&
                              this.state.isAdvanceSearch &&
                              id > 1 ? (
                                <div
                                  className={
                                    this.props.styles
                                      .remove_flight_buttonMultiAdv
                                  }
                                  style={{
                                    display: "flex",
                                    justifyContent: "end",
                                  }}
                                  id="decrease"
                                  onClick={() => {
                                    this.removeList(id);
                                  }}
                                >
                                  {this.crossIcon()}
                                </div>
                              ) : null}
                            </div>
                          </div>

                          {this.state.isAdvanceSearch ? (
                            <label
                              className={`${this.props.styles.checkbox_label}`}
                            >
                              <span className={this.props.styles.bagCheckbox}>
                                <input
                                  type="checkbox"
                                  //  checked={ele.flexiBaggage}
                                  checked={true}
                                  onClick={(e) => this?.flexiBaggageHandler(id)}
                                />
                                <span className={this.props.styles.bagBox}>
                                  <span
                                    className={this.props.styles.bagCheck}
                                  ></span>
                                </span>
                              </span>
                              <span className={this.props.styles.advTitle}>
                                Flexi Baggage
                              </span>
                            </label>
                          ) : null}
                        </>
                      );
                    })}

                  {this.props.isMobile && this.state.isAdvanceSearch
                    ? this.traveller()
                    : this.travellerCabinEle()}

                  <div
                    className={`${this.props.styles.flight_search_details_row}`}
                  >
                    {/* {this.state.isAdvanceSearch ? this.traveller() : ""} */}
                    {this.props?.offlineType !== "Enquiry" &&
                      this?.props?.siteData?.display_supplier_name &&
                      (this.props?.userProfile?.type === "B2B" ||
                        (this.props?.userProfile?.type === "B2E" &&
                          this.props?.userProfile?.user_type === "ADMIN" &&
                          !this.props?.userProfile?.corporate_detail
                            ?.is_corporate_traveller) ||
                        (this.props?.userProfile?.type === "B2E" &&
                          this.props?.userProfile?.user_type === "TD" &&
                          !this.props?.userProfile?.corporate_detail
                            ?.is_corporate_traveller)) && (
                        <div
                          className={`${this.props.styles.flight_search_column} ${this.props.styles.wd_33}`}
                        >
                          <div
                            className={`${this.props.styles.departure_main_box} ${this.props.styles.wd_100}`}
                          >
                            <div className={this.props.styles.label_fname}>
                              <label
                                htmlFor="fname"
                                className={this.props.styles.label_nameAdv}
                              >
                                Supplier
                              </label>
                            </div>
                            <div
                              className={`${this.props.styles.icon_supplier_advInput} ${this.props.styles.advMN_flx}`}
                            >
                              <div className={this.props.styles.icon_box_adv}>
                                <svg
                                  width="15px"
                                  height="15px"
                                  viewBox="0 0 200 200"
                                >
                                  <g>
                                    <path
                                      fill="#30C8CA"
                                      d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                                    ></path>
                                  </g>
                                </svg>
                              </div>
                              {this.props?.multiSelectSupplierDropdown()}
                            </div>
                          </div>
                        </div>
                      )}

                    {false &&
                      this.props?.isOffline === false &&
                      this.props?.userProfile?.type !== "B2E" && (
                        <div
                          className={`${
                            !this.props.isMobile
                              ? this.props.styles.flight_search_column
                              : this.props.styles.mob_flight_search_column
                          } ${
                            this.props.isMobile
                              ? this.props.styles.mob_flight_search_pax
                              : this.props.styles.wd_33
                          }`}
                        >
                          <div
                            className={`${`${this.props.styles.departure_main_box} ${this.props.styles.wd_100}`} `}
                          >
                            <div className={this.props.styles.label_fare}>
                              <label
                                htmlFor="fname"
                                className={this.props.styles.label_nameAdv}
                              >
                                Select Fare Type
                              </label>
                            </div>
                            <div
                              className={`${this.props.styles.icon_box_advInput}`}
                            >
                              <div
                                className={this.props.styles.icon_box_advFare}
                              >
                                <svg
                                  width="15px"
                                  height="15px"
                                  viewBox="0 0 200 200"
                                >
                                  <g>
                                    <path
                                      fill="#30C8CA"
                                      d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                                    ></path>
                                  </g>
                                </svg>
                              </div>
                              {this.props?.selectFareTypeDropdown()}
                            </div>
                          </div>
                        </div>
                      )}
                  </div>

                  {/* button search */}

                  <div className={this.props.styles.multicity_main}>
                    {!this.props.isOffline && (
                      <div className={this.props.styles.SpecialFareTypespace}>
                        {!this.props.isMobile &&
                          this.state.faretypelist?.length > 0 && (
                            <SpecialFareType
                              faretypelist={this.state.faretypelist}
                              title="Select A Fare Type"
                              styles={this.props.styles}
                              handleOnClick={(res, ind) =>
                                this.handleOnClickFareType(res, ind)
                              }
                              disabled={
                                this.state.pax?.child > 0 ||
                                this.state.pax?.infants > 0
                                  ? true
                                  : false
                              }
                              show={true}
                            />
                          )}
                      </div>
                    )}

                    {this.state.selectedTripType === "Multicity"
                      ? this.state.FlightData &&
                        this.state.FlightData.length <= 5 && (
                          <div
                            className={this.props.styles.search_button_section}
                          >
                            <button onClick={this.AddFlightButton}>
                              Add More flight(
                              {this.state.FlightData.length <= 2
                                ? 4
                                : this.state.FlightData.length === 3
                                ? 3
                                : this.state.FlightData.length === 4
                                ? 2
                                : 1}
                              Max) +
                            </button>
                          </div>
                        )
                      : null}

                    <div
                      className={
                        !this.props.isMobile
                          ? this.props.styles.flight_Adv_wrapMU
                          : this.props.styles.mob_flight_search_details_main
                      }
                    >
                      {this.props?.offlineType !== "Enquiry" ? (
                        <button
                          className={`${this.props.styles.flight_AdvBtnMU} ${
                            this.state.btnLoader ? "loading" : ""
                          } `}
                          onClick={() => this.onClickSearchFlight()}
                        >
                          {!this.props.isMobile ? "Search" : "Search Flights"}
                        </button>
                      ) : (
                        <button
                          className={this.props.styles.flight_AdvBtnMU}
                          onClick={() => this.onClickSearchFlightEnquiry()}
                          disabled={this.state.isLoading} // Disable button when loading
                        >
                          {this.state.isLoading ? "Loading..." : "Enquiry"}
                        </button>
                      )}
                    </div>

                    {this.props.isMobile &&
                      this.state.faretypelist?.length > 0 && (
                        <SpecialFareType
                          faretypelist={this.state.faretypelist}
                          title=""
                          styles={this.props.styles}
                          handleOnClick={(res, ind) =>
                            this.handleOnClickFareType(res, ind)
                          }
                          disabled={
                            this.state.pax?.child > 0 ||
                            this.state.pax?.infants > 0
                              ? true
                              : false
                          }
                        />
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.state.showbookingTypeError ? (
          <ModalPopupComponent
            isMobile={true}
            isPopup={true}
            onClosePopup={() => {
              this.setState({
                showbookingTypeError: false,
              });
            }}
            modalCss={this.props.modalCss}
          >
            {this.modalPopupSwitch()}
          </ModalPopupComponent>
        ) : null}

        {this.state.onLoadPopup ? (
          <ModalPopupComponent
            isMobile={true}
            isPopup={true}
            onClosePopup={() => {
              this.closeEnquiry();
            }}
            modalCss={this.props.modalCss}
          >
            <div className={this.props.styles.enquiy_container}>
              <div className={this.props.styles.send_success}>
                <img src="theme4/tick.png" alt="send quote" />
                <div className={this.props.styles.send_lbl}>Send Enquiry</div>
              </div>
              <div className={this.props.styles.enquire_wrap}>
                <span className={this.props.styles.quote_lblTitle}>
                  Enquiry ID: {this.state?.enquiry_id}
                </span>
              </div>
              <span className={this.props.styles.quote_success}>
                Enquiry Request Successful
              </span>
              <div className={this.props.styles.btn_container}>
                <button
                  className={this.props.styles.ok_button}
                  onClick={() => {
                    // this.onButtonEnquiry()
                    window.location.reload();
                    this.closeEnquiry();
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          </ModalPopupComponent>
        ) : null}
      </>
    );
  }
}
